import { Component, ViewChild, TemplateRef, ElementRef, Input, Renderer2, AfterViewInit, OnDestroy, OnInit, OnChanges } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';
import { forkJoin } from 'rxjs';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ActivityGridComponent } from '../../qms/activity-grid/activity-grid.component';
import { AuService } from './au.service';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { TopNavigationComponent } from 'src/app/top-navigation/top-navigation.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivityAuTrailComponent } from 'src/app/qms/activity-au-trail/activity-au-trail.component';
import { FlexibleFieldsComponent } from '../flexible-fields/flexible-fields.component';
import { CoreNavigationService } from 'src/app/support/navigation/core-navigation.service';
import { MatTabGroup } from '@angular/material/tabs';

export interface PopupData {
  title: string;
}
@Component({
  selector: 'app-au',
  templateUrl: './au.component.html',
  styleUrls: ['./au.component.scss']
})

export class AuComponent implements AfterViewInit, OnDestroy, OnInit, OnChanges {
  @Input() activityData: boolean;
  isProcessing: boolean = false;

  infoIconSrc: string = '../../assets/img/info-yellow.png';

  auRefNoTxt: any;
  auditCategoryTxt: any;
  auditClassificationTxt: any;
  auMasterTxt: any;
  auditTypeTxt: any;
  functionalAreaOrServicesTxt: any;
  SubGroupTxt: any;
  leadAuditorTxt: any;
  planApproverTxt: any;
  departmentCodeSearchTxt: any;
  designationCodeTxt: any;
  scheduleApproverTxt: any;
  requestedAtSearchText: string = '';
  businessAreaSearchText: string = '';
  functionalAreaOrServicesSelected: boolean = false;
  pdfColumnTxt: any;
  pdfPageSizes: any = [];
  isAuRefNoOdd: any = null;
  isAuditCategoryOdd: any = null;
  isAuditClassificationOdd: any = null;
  isAuMasterOdd: any = null;
  isAuditTypeOdd: any = null;
  isSubGroupOdd: any = null;
  isLeadAuditorOdd: any = null;
  isPlanApproverOdd: any = null;
  isDepartmentCodeSearchOdd: any = null;
  isScheduleApproverOdd: any = null;
  isRequestedAtOdd: any = null;

  auData: any = {};
  participantData: any = {};
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  auTabPanel: { Name: string }[] = [];
  dateCustomClasses: DatepickerDateCustomClasses[];

  selectedAuditGroup: any = []
  selectedAuditType: any = null;
  selectedAuditCategory: any = null;
  selectedFunctionalAreaOrServices: any = [];
  selectedAuditClassification: any = null;
  selectedRoutineIntervalUnit: any = [];
  selectedDepartment: any = [];
  selectedAuMaster: any = null;
  selectedLeadAuditor: any = null;
  selectedScheduleApprover: any = null;
  selectedPlanApprover: any = null;
  selectedAuRefNo: any = null;
  selectedSubGroup: any = null;
  selectedRole: any = [];
  selectedBusinessArea: any = [];

  dropDownForAuditGroup: any = [];
  dropDownForAuditType: any = [];
  dropDownForAuditCategory: any = [];
  dropDownForFunctionalAreaOrServices: any = [];
  dropDownForAuditClassification: any = [];
  dropDownForRoutineIntervalUnit: any = [];
  dropDownForDepartment: any = [];
  dropDownForAuMaster: any = [];
  dropDownForLeadAuditor: any = [];
  dropDownForScheduleApprover: any = [];
  dropDownForPlanApprover: any = [];
  dropDownForAuRefNoAndSubGroup: any = [];
  dropDownForRole: any = [];
  dropDownForQuesAndAnswerType: any = [];
  dropDownForServicesOffered: any = [];
  requestedAtList: any = [];
  businessAreaList: any = [];

  requestedAtDropdown: any = [];
  businessAreaDropdown: any = [];
  auditGroupDropDown: any = [];
  auditTypeDropDown: any = [];
  auditCategoryDropDown: any = [];
  functionalAreaOrServicesDropDown: any = [];
  auditClassificationDropDown: any = [];
  routineIntervalUnitDropDown: any = [];
  departmentDropDown: any = [];
  auMasterDropDown: any = [];
  leadAuditorDropDown: any = [];
  scheduleApproverDropDown: any = [];
  planApproverDropDown: any = [];
  auRefNoDropDown: any = [];
  subGroupDropDown: any = [];
  roleDropDown: any = [];
  quesAndAnswerTypeDropDown: any = [];
  selectedGroupValue: any = [];

  groupDetailId: any;
  showAuRefNoAsTextBox: any = false;
  showSubGroupAsTextBox: any = false;
  skipValidationsWhileSwitchingUser: boolean = false;
  selectedTabIndex: any;
  showMyTask: any = false;
  showAllTask: any = false;
  showMyFilter: any = false;
  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  };
  objForDocuments: any;
  constructor(
    public router: Router,
    public dialog: MatDialog,
    public auService: AuService,
    public qmsService: qmsService,
    public message: messageService,
    public readonly appService: AppService,
    public paginationService: PaginationService,
    public activityGridComponent: ActivityGridComponent,

    private readonly elem: ElementRef,
    private readonly renderer: Renderer2,
    private readonly snackBar: MatSnackBar,
    private readonly coreNavigationService: CoreNavigationService,
  ) {

    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/dashboard/ActivityCR/AU', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };

  public objectComparisonFunction = function (option: any, value: any): boolean {
    return option.valueExp === value.valueExp;
  };

  @ViewChild('functionalAreaOrServices', { static: false }) functionalAreaOrServicesId!: MatSelect;
  @ViewChild('pdfColumn') pdfColumn: MatSelect;
  allfunctionalAreaSelected = false;
  isAllPdfColumnSelected: boolean = false;
  toggleAllSelection(value: any, e?: any) {
    if (value == 'functionalAreaOrServices') {
      if (this.functionalAreaOrServicesSelected) {
        if (this.functionalAreaOrServicesId) {
          this.functionalAreaOrServicesId?.options.forEach((item: MatOption) => item.select());
        } else {
          if (e.checked) {
            this.selectedFunctionalAreaOrServices = this.functionalAreaOrServicesDropDown.map((item: any) => item.valueExp);;
          }
          this.updateSelectAllState();
        }
      } else {
        if (!this.functionalAreaOrServicesId) {
          this.selectedFunctionalAreaOrServices = [];
          this.updateSelectAllState();
        }
        this.functionalAreaOrServicesId.options.forEach((item: MatOption) => item.deselect());
        this.selectedFunctionalAreaOrServices = [];
      }
    }
    else if (value == 'pdfColumn') {
      if (this.isAllPdfColumnSelected) {
        this.pdfColumn.options.forEach((item: MatOption) => item.select());
      } else {
        this.pdfColumn.options.forEach((item: MatOption) => item.deselect());
      }
    }
  }

  isIndeterminate: boolean = false;
  isSelectAll: boolean = false;
  updateSelectAllState(): void {
    const totalItems = this.functionalAreaOrServicesDropDown.length;
    const selectedItems = this.selectedFunctionalAreaOrServices.length;

    if (selectedItems === totalItems) {
      this.isSelectAll = true;
      this.isIndeterminate = false;
    } else if (selectedItems > 0) {
      this.isSelectAll = false;
      this.isIndeterminate = true;
    } else {
      this.isSelectAll = false;
      this.isIndeterminate = false;
    }
  }

  onFunctionalAreaOrServicesSelect(event: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.functionalAreaOrServicesSelected = this.functionalAreaOrServicesDropDown.length == this.selectedFunctionalAreaOrServices.length;
      })
  }


  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
    this.selectedTab == 'Audit Plan' && this.flexibleComponent.main();

  }


  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  getColor(status: any) {
    if (!status) return '';

    const lowerCasedStatus = status.toLowerCase();

    switch (true) {
      case lowerCasedStatus.includes('rejected') ?? lowerCasedStatus.includes('deleted') ?? lowerCasedStatus.includes('obsoleted'):
        return 'red';
      case lowerCasedStatus.includes('open') ?? lowerCasedStatus.includes('draft') ?? lowerCasedStatus.includes('scheduled') ?? lowerCasedStatus.includes('initiated'):
        return 'orange';
      case lowerCasedStatus.includes('closed') ?? lowerCasedStatus.includes('completed') ?? lowerCasedStatus.includes('approved'):
        return 'green';
      default:
        return '';
    }
  }

  @ViewChild('tabsGroup', { static: false }) tabsGroup: MatTabGroup;
  set tabGroup(tabGroup: MatTabGroup) {
    if (tabGroup)
      setTimeout(() => { this.selectedTabIndex = tabGroup._tabs["_results"].find((t: any) => t.textLabel == this.selectedTabIndex).position; }, 0);
  }

  goToTabByLabel(label: string) {
    if (this.tabsGroup) {
      const tabs = (this.tabsGroup?._tabs as any)._results,
        match = tabs?.find((x: any) => x.textLabel?.toUpperCase() === label.toUpperCase());

      if (match) {
        this.tabsGroup.selectedIndex = match.position;
      }
    }
  }

  tabAccessMethod(priorGroup: any) {
    this.auTabPanel = [];
    let listContains: any = [];

    if (this.auService.auditPageFrom == "MyTask") { /* empty */ } else {
      if (priorGroup.length > 0) {
        let list = priorGroup[0].qmsRoles.split(",");
        let SchedulerGroup = list.filter((value: any) => value === "Scheduler");
        let PlannerGroup = list.filter((value: any) => value === "Planner");
        let ViewerGroup = list.filter((value: any) => value === "Viewer");
        if (SchedulerGroup.length > 0) {
          this.addScheduler = true;
          listContains.push({ Name: "Annual Audit Schedule" });
        }
        if (PlannerGroup.length > 0) {
          this.addplanner = true;
          listContains.push({ Name: "Audit Plan" });
        }

        listContains.push({ Name: "Conduct Audit" });

        if (ViewerGroup.length > 0) {
          listContains = [{ Name: "Annual Audit Schedule" }, { Name: "Audit Plan" }, { Name: "Conduct Audit" }];
        }
      }
      this.auTabPanel = listContains;
      this.selectedTab = this.auService.tabName;
      if (this.coreNavigationService.navigationSource == 'Conduct Audit') {
        setTimeout(() => { this.goToTabByLabel('Conduct Audit') }, 1500)

      }
    }
  }

  addScheduler: boolean = false;
  addplanner: boolean = false;
  filterList: any = [];
  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);
  ngOnInit() {
    this.isProcessing = true;

    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);
    this.dropDownForDepartment = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '[]');
    this.dropDownForDesignation = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '[]');
    let data = {
      status: "active"
    };
    this.selectedTab = this.auService.tabName;
    this.objForDocuments = {
      id: this.message.activityId,
      pagename: this.selectedTab == 'Audit Plan' ? "Plan" : "Schedule"
    };
    forkJoin([
      this.appService.getGroupsModuleCurrentUserVw(this.qmsService.moduleName),
      this.appService.getqmsUserDefaultGroup(this.qmsService.moduleName),
      this.appService.getCodeListsByGroup('AUDIT_CATEGORY'),
      this.appService.getCodeListsByGroup('AU_TYPE'),
      this.appService.getCodeListsByGroup('AUDIT_CLASSIFICATION'),
      this.appService.getCodeListsByGroup('AUDIT_ROUTINE_INTERVAL'),
      this.appService.getCodeListsByGroup("ROLE_CODE"),
      this.appService.getCodeListsByGroup("AUDIT_QA_TYPE"),
      this.appService.getCodeListsByGroup("VENDOR_SERVICES_OFFERED"),
      this.appService.getOneQmsAllUsersVwDetails(data),
      this.appService.getgridfilters('AU_SCHEDULE'),
      this.appService.getQmsReportTemplateDetailsByModuleAndGroupId("AU", this.qmsService.selectedActivityGroupId),
      this.appService.getQmsBusinessAreasByModule('AU'),
    ]).subscribe(([groupData, priorGroupData, categoryData, typeData, classificationData, intervalUnitData, roleData, quesAndAnswData, vendor, userList, filteredData, dropDownDataForReportTemplate1, businessArea]) => {
      this.dropDownDataForReportTemplate = [];

      this.filterList = filteredData;
      this.dropDownForAuditGroup = groupData;
      this.selectBoxForAuditGroup();
      this.selectBoxForDepartment();
      this.selectBoxForDesignation();

      this.requestedAtList = businessArea ?? [];
      this.requestedAtList && this.selectBoxForRequestedAt();

      this.dropDownForServicesOffered = vendor;


      if (this.auService.auditPageFrom == "Main") {
        this.qmsService.cancelButtonFrom = "Activity";
        const priorGroupArray = priorGroupData as any[];
        if (priorGroupArray.length > 0) {
          let priorGroup = this.dropDownForAuditGroup.filter((x: any) => x.groupId === priorGroupArray[0].groupId);
          if (priorGroup.length > 0) {

            this.selectedAuditGroup = [];
            this.selectedAuditGroup.push({
              valueExp: priorGroup[0].groupId,
              displayExp: priorGroup[0].groupName,
            })

            this.onAuditGroupSelect({
              valueExp: priorGroup[0].groupId,
              displayExp: priorGroup[0].groupName,
            })
            this.message.breadcrumbData.secondLevel = "Audit" + " > " + this.selectedAuditGroup[0]?.displayExp;
          }
        } else {
          this.selectedAuditGroup = this.qmsService.SelectedGroupNameAndValue;
          this.onAuditGroupSelect(this.qmsService.SelectedGroupNameAndValue[0]);
        }
      } else if (this.auService.auditPageFrom == "MyTask") {
        if (this.auService.priorGroup) {
          this.onAuditGroupSelect({
            valueExp: this.auService.priorGroup.groupId,
            displayExp: this.auService.priorGroup.groupName,
          });
          this.selectedTab = this.auService.tabName;
          this.selectedAuditGroup = [];
          this.selectedAuditGroup.push({
            valueExp: this.auService.priorGroup.groupId,
            displayExp: this.auService.priorGroup.groupName,
          })

          this.onAuditGroupSelect({
            valueExp: this.auService.priorGroup.groupId,
            displayExp: this.auService.priorGroup.groupName,
          });
          this.qmsService.selectedGroup = this.auService.priorGroup.groupId;
          this.labelCall();
        }
      }

      this.dropDownForAuditCategory = categoryData;
      this.selectBoxForAuditCategory();

      this.dropDownForAuditClassification = classificationData;
      this.selectBoxForAuditClassification();

      this.dropDownForRoutineIntervalUnit = intervalUnitData;
      this.selectBoxForRoutineIntervalUnit();

      this.dropDownForRole = roleData;
      this.selectBoxForRole();

      this.dropDownForQuesAndAnswerType = quesAndAnswData;
      this.selectBoxForQuesAndAnsw();

      this.qmsUsersList = userList;

      this.appService.getOneQmsOrganizationReportImage().subscribe({
        next: (data: any) => {
          this.organizationReportImageDetails = data;
          this.appService.getQmsReportLogoByModuleAndGroupId("QMS", this.qmsService.selectedActivityGroupId).subscribe({
            next: (data: any) => {
              this.dropDownDataForReportLogo = data;
              this.selectBoxForReportLogo();
            }
          });
        },
        error: () => {
          this.isProcessing = false;
        }
      });
      this.ngOnChanges();
    });
    this.ngOnChangesReportFooter();
  }

  ngOnChanges() {
    this.qmsService.refereshBreadCrumb = true;
  }

  private selectBoxForRequestedAt(): void {
    this.requestedAtDropdown = this.requestedAtList?.filter((x: any) => x.module == 'AU')?.map((item: any) => ({
      valueExp: item.taskRequestedAt,
      displayExp: item.taskRequestedAt
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  public onRequestedAtSelect(event: any, item: any): void {
    if (event.isUserInput) {

      if (item) {

        this.auData.requestedAtName = item.displayExp;
        const getBusinessArea = this.requestedAtList?.find((x: any) => x.taskRequestedAt == item.displayExp);
        [this.businessAreaList, this.selectedBusinessArea, this.auData.coreBusinessAreaName] = [[], [], null];
        this.businessAreaList = getBusinessArea?.listOfBusinessArea?.split(',');
        this.selectBoxForBusinessArea();

        setTimeout(() => { this.flexibleComponent.triggerFromRequestedAt(item.valueExp) })
      } else {

        this.businessAreaList = [];
        this.businessAreaDropdown = [];
        this.auData.requestedAtName = '';
      }
    }
  }

  private selectBoxForBusinessArea(): void {
    this.businessAreaDropdown = this.businessAreaList?.map((bArea: any) => ({
      valueExp: bArea,
      displayExp: bArea
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  isAllBusinessAreaSelected?: boolean = false
  public onBusinessAreaSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('business-area', this.selectedBusinessArea)
        this.isAllBusinessAreaSelected = this.businessAreaDropdown.length == this.selectedBusinessArea.length;
      });
  }

  @ViewChild('businessArea') businessArea: MatSelect;
  public toggleAllBusinessArea(): void {
    if (this.isAllBusinessAreaSelected) {
      for (const item of this.businessArea.options) item.select();
    } else {
      for (const item of this.businessArea.options) item.deselect();
      this.selectedBusinessArea = [];
    }

    setTimeout(() => { this.handleDropDownValidation('business-area', this.selectedBusinessArea); });
  }

  public getTooltip(): string {
    return this.selectedBusinessArea.join(',');
  }

  selectBoxForAuditGroup() {
    this.auditGroupDropDown = [];
    this.auditGroupDropDown = this.dropDownForAuditGroup?.map((item: { groupId: any; groupName: any; }) => ({
      valueExp: item.groupId,
      displayExp: item.groupName
    })) ?? []
  }

  showgrid: any
  onAuditGroupSelect(item: any) {
    this.showgrid = true;
    this.isProcessing = true;
    const priorGroup = this.dropDownForAuditGroup.filter((x: any) => x.groupId === item.valueExp);
    if (priorGroup) {
      this.tabAccessMethod(priorGroup);
    }

    this.qmsService.selectedActivityGroupId = item.valueExp;
    this.handleDropDownValidation('group-validation', this.selectedAuditGroup);
    this.gourpDetailsCall(item.valueExp);
    const data = {
      moduleName: this.qmsService.moduleName,
      groupId: this.qmsService.selectedActivityGroupId,
    }

    this.appService.callSetDefaultGrouop(data).subscribe((data: any) => {
      this.isProcessing = false;
    })

    this.appService.getQmsActiveUserByGroupIdModuleUserId(item.valueExp, this.qmsService.moduleName).subscribe((data: any) => {
      this.qmsService.userRole = data;
      if (this.qmsService.userRole[0].qmsRoles.includes("Auditor")) {
        this.qmsService.loggedAuditor = true;
      } else {
        this.qmsService.loggedAuditor = false;
      }

    });
    this.allvendorList = [];
    this.appService.getAuMasterByGroupId(item.valueExp).subscribe((data: any) => {
      this.allvendorList = data;
      this.dropDownForAuMaster = data.filter((vendor: any) => vendor.isActive == 'Y');
      if (this.dropDownForAuMaster.length > 0) this.selectBoxForAuMaster();
    })

    this.appService.getQmsGroupDetailsByModule(item.valueExp, this.qmsService.moduleName).subscribe((data: any) => {
      this.groupDetailId = data.groupDetailId;
      this.qmsService.selectedGroupDetailData = data;
      this.qmsService.selectedGroupDetailId = this.groupDetailId;

      if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic") {
        this.showMyTask = false;
        this.showAllTask = false;
        this.showMyFilter = false;
      } else if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic + All") {
        this.showMyTask = false;
        this.showAllTask = true;
        this.showMyFilter = false;
      } else if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic + All + My Task") {
        this.showMyTask = true;
        this.showAllTask = true;
        this.showMyFilter = false;
      }
      else if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic + Filter") {
        this.showMyTask = false;
        this.showAllTask = false;
        this.showMyFilter = true;
      } else if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic + All + Filter") {
        this.showMyTask = false;
        this.showAllTask = true;
        this.showMyFilter = true;
      } else if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic + My Task") {
        this.showMyTask = true;
        this.showAllTask = false;
        this.showMyFilter = false;
      } else if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic + My Task + Filter") {
        this.showMyTask = true;
        this.showAllTask = false;
        this.showMyFilter = true;
      } else {
        this.showMyTask = true;
        this.showAllTask = true;
        this.showMyFilter = true;
      }

      this.appService.getQmsGroupDetailsByGroupDetailId(this.selectedAuditGroup[0].valueExp, this.groupDetailId).subscribe((data: any) => {
        if (data) {
          this.dropDownForAuRefNoAndSubGroup = data;
          this.showAuRefNoAsTextBox = data.auditAnnualRefList ? (this.selectBoxForAuRefNo(), false) : true;
          this.showSubGroupAsTextBox = data.auditSubGroupList ? (this.selectBoxForSubGroup(), false) : true;
        }
        this.isProcessing = false;
        if (this.auService.auditPageFrom == "MyTask") {
          this.openEditPopup(this.auService.tabName, this.auService.list, 'DETAILS');
        }
      });

    })

    this.appService.getQmsActiveGroupUsers(item.valueExp, this.qmsService.moduleName, 'Scheduler').subscribe((data: any) => {
      if (data.length > 0) {
        this.dropdownForSchedulers = data;
      }
    });

    this.appService.getQmsActiveGroupUsers(item.valueExp, this.qmsService.moduleName, 'Planner').subscribe((data: any) => {
      if (data.length > 0) {
        this.dropdownForPlanners = data;
      }
    });

    const getAndUpdateRolesDropdown = (role: string, selectBoxFunction: () => void) => {
      this.appService.getQmsActiveGroupUsers(item.valueExp, this.qmsService.moduleName, role).subscribe((data: any) => {
        if (data.length > 0) {

          if (role == 'Auditor') {
            this.dropDownForLeadAuditor = data;
          } else if (role == 'Schedule Approver') {
            this.dropDownForScheduleApprover = data;
          } else {
            this.dropDownForPlanApprover = data;
          }

          selectBoxFunction();
        }
      });
    };

    getAndUpdateRolesDropdown("Auditor", this.selectBoxForLeadAuditor.bind(this));
    getAndUpdateRolesDropdown("Schedule Approver", this.selectBoxForScheduleApprover.bind(this));
    getAndUpdateRolesDropdown("Plan Approver", this.selectBoxForPlanApprover.bind(this));
    this.isProcessing = false;
  }

  dropdownForSchedulers: any = [];
  dropdownForPlanners: any = [];

  onAuditGroupDeSelect() {
    this.showgrid = false;
    this.handleDropDownValidation('group-validation', this.selectedAuditGroup)
  }
  allvendorList: any;
  selectBoxForAuRefNo() {
    this.auRefNoDropDown = [];
    this.auRefNoDropDown = this.dropDownForAuRefNoAndSubGroup?.auditAnnualRefList.split(',').map((item: any) => ({
      valueExp: item,
      displayExp: item
    })) ?? []
  }

  selectBoxForAuditCategory() {
    this.auditCategoryDropDown = [];
    this.auditCategoryDropDown = this.dropDownForAuditCategory?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) ?? []
  }

  freezeAuditTypeDropDown: boolean = true;
  findingVendor: any = [];
  findingDepartment: any = [];

  onAuditCategorySelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('category-validation', item);
      if (item) {
        this.isProcessing = true;
        this.displayVendor = this.displayDepartment = this.displayFunctionalAreaOrServices = false;
        this.auData = { ...this.auData, vendorId: '', vendorName: '', departmentId: '', departmentName: '' };
        [this.selectedAuditType, this.selectedFunctionalAreaOrServices] = [null, []];
        if (item.displayExp == 'External') {
          this.findingVendor = this.dropDownForAuditType?.filter((vendor: any) => vendor.type.toLowerCase().trim().includes('vendor')) ?? [];
          this.auditTypeDropDown = this.findingVendor?.map((item: any) => ({
            valueExp: item.type,
            displayExp: item.type
          })) ?? [];
          if (this.findingVendor.length > 0) {
            let selectedAuditType = [{ valueExp: this.findingVendor[0].type, displayExp: this.findingVendor[0].type }]
            this.selectedAuditType = this.qmsService.selectedAuditType = this.findingVendor[0].type;
            this.freezeAuditTypeDropDown = true;
            this.onAuditTypeSelect(this.event, selectedAuditType[0]);
          }
        } else {
          const filteredDepartments = this.dropDownForAuditType?.filter((vendor: any) => !vendor.type.toLowerCase().trim().includes('vendor')) ?? [];
          this.findingDepartment = [...filteredDepartments];

          if (this.findingDepartment.length === 1) {
            let selectedAuditType = [{ valueExp: this.findingDepartment[0].type, displayExp: this.findingDepartment[0].type }]
            this.selectedAuditType = this.qmsService.selectedAuditType = this.findingDepartment[0].type;
            this.freezeAuditTypeDropDown = true;
            this.onAuditTypeSelect(this.event, selectedAuditType[0]);
            this.auditTypeDropDown = this.findingDepartment?.map((item: any) => ({
              valueExp: item.type,
              displayExp: item.type
            })) ?? [];
          } else {
            this.freezeAuditTypeDropDown = false;

            this.auditTypeDropDown = this.findingDepartment?.map((item: any) => ({
              valueExp: item.type,
              displayExp: item.type
            })) ?? [];
          }
        }
        setTimeout(() => {
          this.isProcessing = false;
        }, 1000);
      } else {
        this.displayVendor = this.displayDepartment = this.displayFunctionalAreaOrServices = false;
        this.auData = { ...this.auData, vendorId: '', vendorName: '', departmentId: '', departmentName: '' };
        [this.selectedAuditType, this.selectedFunctionalAreaOrServices] = [null, []];
        this.freezeAuditTypeDropDown = true;
      }
    }
  }

  onAuditCategoryDeselect() {
    this.displayVendor = this.displayDepartment = this.displayFunctionalAreaOrServices = false;
    this.auData = { ...this.auData, vendorId: '', vendorName: '', departmentId: '', departmentName: '' };
    [this.selectedAuditType, this.selectedFunctionalAreaOrServices] = [null, []];
    this.freezeAuditTypeDropDown = true;
    this.handleDropDownValidation('category-validation', this.selectedAuditCategory);
  }

  selectBoxForAuditType() {
    this.auditTypeDropDown = [];
    this.auditTypeDropDown = this.dropDownForAuditType?.map((item: any) => ({
      valueExp: item.type,
      displayExp: item.type
    })) ?? []
  }

  isForDepartment: boolean = false;
  isForVendor: boolean = false;
  displayVendor: boolean = false;
  displayDepartment: boolean = false;

  detailsId: any = null;
  auditTypeList: any = [];
  gourpDetailsCall(groupId: any) {
    this.appService.getQmsGroupDetailsByModule(groupId, this.qmsService.moduleName).subscribe((data: any) => {
      this.detailsId = data.groupDetailId;
      this.qmsService.selectedGroupDetailData = data;
      this.qmsService.selectedGroupDetailId = this.detailsId;
      this.setChart();
      this.prepareAuditType(groupId);
    })
  }

  prepareAuditType(groupId: any) {
    this.appService.getCodeListsByGroup(this.qmsService.moduleName + "_TYPE").subscribe((response: any) => {
      this.appService.getTypeSettingsByGrpIdGrpDetailId(groupId, this.detailsId).subscribe((response: any) => {
        this.auditTypeList = [];
        for (const item of response) {
          if (item.type.includes("Findings")) continue;
          this.auditTypeList.push(item);
        }

        this.dropDownForAuditType = this.auditTypeList;
        if (this.auData.auditType) {
          for (const item of this.dropDownForAuditType) {
            if (item.type === this.auData.auditType) {
              this.selectedAuditType = this.qmsService.selectedAuditType = item.type;
            }
          }
        }
        setTimeout(() => { this.selectBoxForAuditType(); })
      })
    });
  }

  setChart() {
    if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic") {
      this.showMyTask = false;
      this.showAllTask = false;
      this.showMyFilter = false;
    } else if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic + All") {
      this.showMyTask = false;
      this.showAllTask = true;
      this.showMyFilter = false;
    } else if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic + All + My Task") {
      this.showMyTask = true;
      this.showAllTask = true;
      this.showMyFilter = false;
    }
    else if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic + Filter") {
      this.showMyTask = false;
      this.showAllTask = false;
      this.showMyFilter = true;
    } else if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic + All + Filter") {
      this.showMyTask = false;
      this.showAllTask = true;
      this.showMyFilter = true;
    } else if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic + My Task") {
      this.showMyTask = true;
      this.showAllTask = false;
      this.showMyFilter = false;
    } else if (this.qmsService.selectedGroupDetailData.masterpageDashboard == "Basic + My Task + Filter") {
      this.showMyTask = true;
      this.showAllTask = false;
      this.showMyFilter = true;
    } else {
      this.showMyTask = true;
      this.showAllTask = true;
      this.showMyFilter = true;
    }
  }

  onAuditTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.qmsService.selectedAuditType = item;
        this.isProcessing = true;
        this.displayVendor = this.displayDepartment = this.displayFunctionalAreaOrServices = false;
        this.auData = { ...this.auData, vendorId: '', vendorName: '', departmentId: '', departmentName: '' };
        this.selectedFunctionalAreaOrServices = [];
        setTimeout(() => {
          this.handleDropDownValidation('type-validation', this.selectedAuditType);
        });
        if (this.selectedAuditType?.toLowerCase().trim().includes('vendor')) {
          this.displayVendor = true;
        } else {
          this.displayDepartment = true;
        }

        if (item.valueExp == 'NA') {
          /* If NA handle here */
        } else {
          this.appService.getTypeSettingsByType(this.selectedAuditGroup[0].valueExp, this.detailsId, item.valueExp).subscribe((response: any) => {
            if (response.toBeStartedInDays != null) {
              let date = new Date();
              date.setHours(12);
              date.setMinutes(0);
              date.setSeconds(0);
              date.setDate(date.getDate() + response.toBeStartedInDays);
              this.auData.expectedToBeStartedOn = date;
            }
            if (response.toBeClosedInDays != null) {
              let date = new Date();
              date.setHours(12);
              date.setMinutes(0);
              date.setSeconds(0);
              this.auData.expectedToBeStartedOn == null ? date.setDate(date.getDate() + response.toBeClosedInDays) : date.setDate(date.getDate() + response.toBeStartedInDays + response.toBeClosedInDays);
              this.auData.expcetedClosureOn = date;
            }
            this.isProcessing = false;
          })
        }
      } else {
        this.displayVendor = this.displayDepartment = this.displayFunctionalAreaOrServices = false;
        this.auData = { ...this.auData, vendorId: '', vendorName: '', departmentId: '', departmentName: '' };
        this.selectedFunctionalAreaOrServices = [];
        setTimeout(() => {
          this.handleDropDownValidation('type-validation', this.selectedAuditType);
        });
      }
    }
  }

  onAuditTypeDeselect() {
    this.displayVendor = this.displayDepartment = this.displayFunctionalAreaOrServices = false;
    this.auData = { ...this.auData, vendorId: '', vendorName: '', departmentId: '', departmentName: '' };
    this.selectedFunctionalAreaOrServices = [];
    this.handleDropDownValidation('type-validation', this.selectedAuditType);
  }

  selectBoxForFunctionalAreaOrServices() {
    this.functionalAreaOrServicesDropDown = null;
    this.functionalAreaOrServicesDropDown = this.dropDownForFunctionalAreaOrServices?.map((item: any) => ({
      valueExp: item,
      displayExp: item
    })) ?? []
  }

  selectBoxForAuditClassification() {
    this.auditClassificationDropDown = null;
    this.auditClassificationDropDown = this.dropDownForAuditClassification?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) ?? []
  }

  showRoutineFields: boolean;
  onClassificationSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.handleDropDownValidation('classification-validation', item);
        if (item.displayExp == 'Routine Audit') this.showRoutineFields = true;
        else this.showRoutineFields = false;
      } else {
        this.handleDropDownValidation('classification-validation', item);
        if (this.showRoutineFields) this.showRoutineFields = false;
      }
    }
  }

  onClassificationDeSelect(item: any) {
    this.handleDropDownValidation('classification-validation', this.selectedAuditClassification);
    if (this.showRoutineFields) this.showRoutineFields = false;
  }

  selectBoxForLeadAuditor() {
    this.leadAuditorDropDown = [];
    this.leadAuditorDropDown = this.dropDownForLeadAuditor?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    })) ?? []
  }

  onLeadAuditorSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.selectedTab == 'Audit Plan' && this.handleDropDownValidation('lead-auditor-validation', this.selectedLeadAuditor) });
      if (item) {
        if (this.participantData.applicationUserId == item.valueExp) {
          setTimeout(() => {
            this.showSnackBar('Lead Auditor and Participant cannot be the same user', 'E');
            this.selectedLeadAuditor = null;
          });
        }
      }
    }
  }

  onLeadAuditorDeSelect() {
    this.selectedTab == 'Audit Plan' && this.handleDropDownValidation('lead-auditor-validation', this.selectedLeadAuditor);
  }

  selectBoxForScheduleApprover() {
    this.scheduleApproverDropDown = [];
    this.scheduleApproverDropDown = this.dropDownForScheduleApprover?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    })) ?? []
  }

  onScheduleApproverSelect() {
    this.handleDropDownValidation('schedule-approver-validation', this.selectedScheduleApprover);
  }

  onScheduleApproverDeSelect() {
    this.handleDropDownValidation('schedule-approver-validation', this.selectedScheduleApprover);
  }

  selectBoxForPlanApprover() {
    this.planApproverDropDown = [];
    this.planApproverDropDown = this.dropDownForPlanApprover?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    })) ?? []
  }

  onPlanApproverSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.handleDropDownValidation('plan-approver-validation', this.selectedPlanApprover) });
      if (item) {

      }
    }
  }

  onPlanApproverDeSelect() {
    this.handleDropDownValidation('plan-approver-validation', this.selectedPlanApprover);
  }

  selectBoxForRoutineIntervalUnit() {
    this.routineIntervalUnitDropDown = [];
    this.routineIntervalUnitDropDown = this.dropDownForRoutineIntervalUnit?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) ?? []
  }

  onIntervalUnitSelect() {
    this.handleDropDownValidation('internal-unit-validation', this.selectedRoutineIntervalUnit)
  }

  onIntervalUnitDeSelect() {
    this.handleDropDownValidation('internal-unit-validation', this.selectedRoutineIntervalUnit)
  }

  selectBoxForAuMaster() {
    this.auMasterDropDown = [];
    this.auMasterDropDown = this.dropDownForAuMaster.map((item: any) => ({
      valueExp: item.auditMasterId,
      displayExp: item.description
    })) ?? []
  }

  onAuMasterSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.freezeAuditTypeDropDown = false;
      if (item) {
        this.isProcessing = true
        this.functionalAreaOrServicesSelected = false;
        this.appService.getAuMasterByAuMasterId(item.valueExp).subscribe((data: any) => {

          if (data.auditType) {
            const matchingType = this.dropDownForAuditType.find((item: any) => item.type == data.auditType);
            if (matchingType) {
              this.auditTypeDropDown = [{ valueExp: matchingType.type, displayExp: matchingType.type }];
              const selectedAuditType = [{ valueExp: matchingType.type, displayExp: matchingType.type }];
              this.selectedAuditType = this.qmsService.selectedAuditType = matchingType.type;
              this.onAuditTypeSelect(this.event, selectedAuditType[0]);
            }
          }

          if (data.auditClassification) {
            const matchingClassification = this.dropDownForAuditClassification.find((item: any) => item.codelistCode == data.auditClassification);
            if (matchingClassification) {
              this.selectedAuditClassification = matchingClassification.codelistCode;
              if (matchingClassification.codelistName == 'Routine Audit') this.showRoutineFields = true;
              else this.showRoutineFields = false;
            }
          }

          if (data.auditScope) {
            this.auData.auditScope = data.auditScope;
          }

          if (data.vendorId) {
            this.displayVendor = true;
            this.auData.vendorId = data.vendorId;

            this.appService.getQmsVendorsVwDetailsByVendorId(data.vendorId).subscribe((vendorData: any) => {
              this.auData.vendorName = vendorData.vendorName;
            });
          }

          if (data.auditDepartment || data.departmentId) {
            this.displayDepartment = true;
            this.auData.departmentId = data.auditDepartment || data.departmentId;

            this.appService.getCodeListsByGroup('AUDIT_DEPARTMENT').subscribe((departmentData: any) => {
              const foundDepartment = departmentData?.find((dept: any) => this.auData.departmentId === dept.codelistCode);
              if (foundDepartment) {
                this.auData.departmentName = foundDepartment.codelistName;
              }
            });
          }

          if (data.functionalAreaOrServices) {
            this.displayFunctionalAreaOrServices = true;
            const savedAreas = data.functionalAreaOrServices.split(',');
            this.selectedFunctionalAreaOrServices = savedAreas;

            this.functionalAreaOrServicesDropDown = savedAreas.map((area: string) => ({
              valueExp: area,
              displayExp: area
            }));
            this.updateSelectAllState();
          }

          if (data.auditPurpose) {
            this.auData.auditPurpose = data.auditPurpose;
          }

          if (data.auditReferences) {
            this.auData.auditReferences = data.auditReferences;
          }

          if (data.subcategory) {
            const matchingAuditCategory = this.dropDownForAuditCategory?.find((item: any) => item.codelistCode == data.subcategory)
            if (matchingAuditCategory) {
              this.selectedAuditCategory = matchingAuditCategory.codelistCode;
            }
          }

          if (data.remarks) {
            this.auData.remarks = data.remarks;
          }

          setTimeout(() => {
            this.handleDropDownValidation('type-validation', this.selectedAuditType);
            this.handleDropDownValidation('classification-validation', this.selectedAuditClassification);
            this.onNgModelChange(this.auData.auditScope, 'scope-validation');
            this.onNgModelChange(this.auData.auditPurpose, 'purpose-validation');
            this.onNgModelChange(this.auData.auditReferences, 'references-validation');
            this.onNgModelChange(this.auData.expectedToBeStartedOn, 'expected-start-validation');
            if (this.displayVendor) this.onNgModelChange(this.auData.vendorId, 'vendor-validation');
            if (this.displayDepartment) this.onNgModelChange(this.auData.departmentId, 'department-validation');
            this.handleDropDownValidation('category-validation', this.selectedAuditCategory);
            this.onNgModelChange(this.auData.remarks, 'remarks-validation');
          }, 500)
          this.isProcessing = false;
        })
      }
    }
  }

  selectBoxForSubGroup() {
    this.subGroupDropDown = [];
    this.subGroupDropDown = this.dropDownForAuRefNoAndSubGroup?.auditSubGroupList?.split(',').map((item: any) => ({
      valueExp: item,
      displayExp: item
    })) ?? []
  }

  selectBoxForRole() {
    this.roleDropDown = [];
    this.roleDropDown = this.dropDownForRole?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) ?? []
  }

  selectBoxForQuesAndAnsw() {
    this.quesAndAnswerTypeDropDown = [];
    this.quesAndAnswerTypeDropDown = this.dropDownForQuesAndAnswerType?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) ?? []
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
    itemsShowLimit: 4,
  };

  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
  };

  dateTimeConfig = {
    ...this.commonDateConfig,
    dateInputFormat: this.dateFormat + ' HH:mm:ss'
  }


  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: false }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;
  @ViewChild('vendorPopup', { static: true }) vendorPopup: TemplateRef<any>;
  visibleVendorPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('departmentPopup', { static: true }) departmentPopup: TemplateRef<any>;
  visibleDepartmentPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('participantPopup', { static: true }) participantPopup: TemplateRef<any>;
  visibleParticipantPopup: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  addAndEditPopupConfig = {
    width: '110%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { left: '105px', top: '5px' },
    maxWidth: '93vw',
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  vendorPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  departmentPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  participantPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  auProposedDateConfig = {
    ...this.commonDateConfig,
    minDate: new Date(),
  }

  expectedToBeStartedOnDateConfig = {
    ...this.commonDateConfig,
    minDate: new Date(),
  }

  onExpectedStartedOnChange() {
    if (this.auData.expcetedClosureOn && this.auData.expectedToBeStartedOn > this.auData.expcetedClosureOn) this.auData.expcetedClosureOn = null;
  }

  expectedClosureOnDateConfig() {
    return {
      ...this.commonDateConfig,
      minDate: this.auData.expectedToBeStartedOn ? new Date(this.auData.expectedToBeStartedOn) : new Date(),
    }
  }

  startDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    minDate: new Date(),
  };

  onStartDateChange() {
    if (this.auData.endDate && this.auData.startDate > this.auData.endDate) this.auData.endDate = null;
    this.auEndDateConfig();
  };

  auEndDateConfig() {
    return {
      ...this.commonDateConfig,
      minDate: this.auData.startDate ? new Date(this.auData.startDate) : new Date(),
    }
  }

  endDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    minDate: new Date(this.auData.expectedToBeStartedOn)
  }

  popupDataTitle: PopupData = {
    title: 'PDF'
  };

  searchByVendorName: string;
  searchByVendorCode: string;
  getCheckedVendorName: string;
  getCheckedVendorId: string;
  getCheckedServicesOffered: string;
  showVendorGrid: boolean = false;
  noResultFound: boolean = false;
  vendorList: any = [];

  openVendorPopup() {
    [
      this.searchByVendorName,
      this.searchByVendorCode,
      this.getCheckedVendorName,
      this.getCheckedVendorId,
      this.getCheckedServicesOffered,
      this.vendorList
    ] = ['', '', '', '', '', []];

    this.showVendorGrid = false;
    this.previousRow = undefined;
    this.visibleVendorPopup = this.dialog.open(this.vendorPopup, this.vendorPopupConfig);
  }

  cancelVendorPopup() {
    this.visibleVendorPopup.close();
  }

  searchVendorFunc() {
    this.isProcessing = true;
    let data = {
      vendorName: this.searchByVendorName ? this.searchByVendorName : null,
      vendorCode: this.searchByVendorCode ? this.searchByVendorCode : null,
      groupId: "" + this.qmsService.selectedActivityGroupId
    }
    this.appService.fetchVendorListWithSearchCriteria(data).subscribe((vendorData: any) => {
      this.vendorList = vendorData;
      if (this.vendorList.length > 0) this.showVendorGrid = true;
      else this.noResultFound = true;
      this.isProcessing = false;
    })
  }

  resetVendorFunc() {
    [
      this.searchByVendorName,
      this.searchByVendorCode,
      this.getCheckedVendorName,
      this.getCheckedVendorId,
      this.getCheckedServicesOffered,
      this.vendorList
    ] = ['', '', '', '', '', []];
    this.showVendorGrid = false;
  }
  previousRow: any;
  vendorGridCheckBox(e: any, vendorData: any, idx: any) {

    if (e.target.checked) {
      vendorData.vendorChildCheckBoxs = true;
      [this.getCheckedVendorName, this.getCheckedVendorId, this.getCheckedServicesOffered] = [vendorData.vendorName, vendorData.vendorId, vendorData.servicesOffered];
    } else {
      vendorData.vendorChildCheckBoxs = false;
      [this.getCheckedVendorName, this.getCheckedVendorId] = ['', ''];
    }
    if (this.previousRow != null || this.previousRow != undefined) {
      this.vendorList[this.previousRow].vendorChildCheckBoxs = false;
    }
    this.previousRow = idx;
  }

  displayFunctionalAreaOrServices: boolean = false;
  selectVendor() {
    this.selectedFunctionalAreaOrServices = [];
    this.isProcessing = true;
    [this.auData.vendorName, this.auData.vendorId, this.dropDownForFunctionalAreaOrServices] = [this.getCheckedVendorName, this.getCheckedVendorId, this.getCheckedServicesOffered ? this.assignVendorFunctionalService(this.getCheckedServicesOffered?.split(',')) : []];
    this.displayFunctionalAreaOrServices = true;
    this.isProcessing = false;
    this.selectBoxForFunctionalAreaOrServices();
    this.visibleVendorPopup.close();
  }

  assignVendorFunctionalService(vendor: any) {
    return this.dropDownForServicesOffered.filter((service: any) => vendor.includes(service.codelistCode)).map((x: any) => x.codelistName);
  }

  searchByGroupName: string;
  searchByCodeListName: string;
  searchByCodeListCode: string;
  getCheckedDepartmentName: string;
  getCheckedDepartmentCode: string;
  getSubgroupValues: string;
  departmentList: any = [];

  openDepartmentPopup() {
    [
      this.searchByCodeListName,
      this.searchByCodeListCode,
      this.getCheckedDepartmentName,
      this.getCheckedDepartmentCode,
      this.getSubgroupValues,
      this.departmentList
    ] = ['', '', '', '', '', []];
    this.searchByGroupName = this.selectedAuditType;
    this.visibleDepartmentPopup = this.dialog.open(this.departmentPopup, this.departmentPopupConfig);
  }

  cancelDepartmentPopup() {
    this.visibleDepartmentPopup.close();
  }

  searchDepartmentFunc() {
    this.isProcessing = true;
    let data = {

      groupName:/*  this.searchByGroupName.toUpperCase(), */ 'AUDIT_DEPARTMENT',
      codelistCode: this.searchByCodeListCode ? this.searchByCodeListCode : null,
      codelistName: this.searchByCodeListName ? this.searchByCodeListName : null
    }
    this.appService.fetchDepartmentListWithSearchCriteria(data).subscribe((departmentData: any) => {
      let list = departmentData.filter((x: any) => x.isActive === 'Y');
      this.departmentList = list;
      if (this.departmentList.length < 1) this.noResultFound = true;
      else this.noResultFound = false;
      this.isProcessing = false;
    })
  }

  resetDepartmentFunc() {
    [
      this.searchByCodeListName,
      this.searchByCodeListCode,
      this.getCheckedDepartmentName,
      this.getCheckedDepartmentCode,
      this.getSubgroupValues,
      this.departmentList
    ] = ['', '', '', '', '', []];
  }

  departmentGridCheckBox(e: any, departmentData: any, idx: any) {
    this.departmentList.every((item: any) => { if (item.departmentChildCheckBox) { item.departmentChildCheckBox = false; } return true; })

    if (e.target.checked) {
      departmentData.departmentChildCheckBox = true;
      [this.getCheckedDepartmentName, this.getCheckedDepartmentCode, this.getSubgroupValues] = [departmentData.codelistName, departmentData.codelistsPk.codelistCode, departmentData.subgroupValues];
    } else {
      departmentData.departmentChildCheckBox = true;
      [this.getCheckedDepartmentName, this.getCheckedDepartmentCode] = ['', ''];
    }
  }

  selectDepartment() {
    [this.auData.departmentName, this.auData.departmentId, this.dropDownForFunctionalAreaOrServices] =
      [this.getCheckedDepartmentName, this.getCheckedDepartmentCode, this.getSubgroupValues?.split(',')];

    this.appService.getCodeListsByGroup('AUDIT_DEPARTMENT').subscribe((departmentData: any) => {
      const foundDepartment = departmentData?.find((department: any) => this.getCheckedDepartmentCode === department.codelistCode)
      if (foundDepartment) {
        this.isProcessing = false;
        this.functionalAreaOrServicesSelected = false;
        this.auData.departmentName = foundDepartment.codelistName;
        this.auData.departmentId = foundDepartment.codelistCode;
        this.dropDownForFunctionalAreaOrServices = foundDepartment.subgroupValues?.split(',') ?? [];
        this.selectBoxForFunctionalAreaOrServices();
        this.displayFunctionalAreaOrServices = true;
        this.visibleDepartmentPopup.close();
        this.selectedFunctionalAreaOrServices = [];
      }
    })
  }

  displayParticipantGrid: boolean = false;
  searchByUserName: any;
  searchByFirstName: any;
  searchByLastName: any;
  searchByEmailAddress: any;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  participantListForGrid: any = [];

  private resetParticipantPopupState(): void {
    this.displayParticipantGrid = false;
    this.isPrimaryAuditee = false;
    this.searchByUserName = '';
    this.searchByFirstName = '';
    this.searchByLastName = '';
    this.searchByEmailAddress = '';
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.participantListForGrid = [];
    this.primaryAuditeeList = [];
    this.isProcessing = false;
  }

  openParticipantPopup() {

    this.resetParticipantPopupState();
    this.displayParticipantGrid = false;
    this.isPrimaryAuditee = false;

    [
      this.searchByUserName,
      this.searchByFirstName,
      this.searchByLastName,
      this.searchByEmailAddress
    ] = new Array(4).fill('');

    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;

    this.participantListForGrid?.forEach((p: any) => p.participantChildCheckBox = false);
    this.primaryAuditeeList?.forEach((p: any) => p.participantChildCheckBox = false);

    this.primaryAuditeeList = [];

    this.appService
      .getQmsActiveGroupUsers(
        this.qmsService.selectedActivityGroupId,
        this.qmsService.moduleName,
        'Primary Auditee'
      )
      .subscribe((data: any) => {
        this.primaryAuditeeList = data;
      });

    // 🔹 Open dialog fresh
    this.visibleParticipantPopup = this.dialog.open(
      this.participantPopup,
      {
        ...this.participantPopupConfig,
        disableClose: true // ⛔ prevent auto-close
      }
    );
  }


  primaryAuditeeList: any = [];
  isPrimaryAuditee: boolean = false;
  searchParticipant() {
    this.isProcessing = true;
    let data = {
      userName: this.searchByUserName == null ? "" : this.searchByUserName.toUpperCase(),
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      emailAddress: this.searchByEmailAddress,
      designationCode: this.searchByDesignationCode ?? null,
      departmentCode: this.searchByDepartmentCode ?? null,
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(data).subscribe((response: any) => {
      this.participantListForGrid = response?.sort((m: { userName: string; }, n: { userName: string; }) => m.userName.trim().localeCompare(n.userName.trim()));
      this.displayParticipantGrid = true;
      this.isProcessing = false;
    })
  }

  getApplicationUserId: any;
  getParticipantName: string;
  participantChildCheckBoxChecked(e: any, gridData: any, idx: any) {
    if (this.isPrimaryAuditee) {
      this.primaryAuditeeList.every((item: any) => { if (item.participantChildCheckBox) { item.participantChildCheckBox = false; } return true; })
    } else {
      this.participantListForGrid.every((item: any) => { if (item.participantChildCheckBox) { item.participantChildCheckBox = false; } return true; })
    }
    if (e.target.checked) {
      gridData.participantChildCheckBox = true;
      this.getApplicationUserId = gridData.userId;
      this.getParticipantName = gridData.userName;
    } else {
      gridData.participantChildCheckBox = false;
      this.getApplicationUserId = null;
      this.getParticipantName = '';
    }
  }

  resetParticipant() {
    this.displayParticipantGrid = false;
    [
      this.searchByUserName,
      this.searchByFirstName,
      this.searchByLastName,
      this.searchByEmailAddress
    ] = new Array(4).fill('');
    this.isPrimaryAuditee = false;
    [this.searchByDesignationCode, this.searchByDepartmentCode, this.participantListForGrid] = [[], [], []]
  }

  toggle(event: MatSlideToggleChange) {
    if (event.checked) {
      this.participantListForGrid = [];
    } else {
      for (const element of this.primaryAuditeeList) {
        element.participantChildCheckBox = false;
      }
    }
  }

  selectParticipant() {
    if (this.selectedLeadAuditor == this.getApplicationUserId) {
      this.visibleAuditeeAlertPopup = this.dialog.open(this.auditeeAlertPopup, this.auditeeAlertPopupConfig);
    } else {
      this.participantData.applicationUserId = this.getApplicationUserId;
      this.participantData.participantName = this.getParticipantName;
      this.onNgModelChange(this.participantData.participantName, 'participant-validation');
      this.visibleParticipantPopup.close();
    }
  }

  cancelParticipantSelect() {
    this.visibleParticipantPopup.close();
  }

  createNewPlan() {
    this.auService.questionnaireList = [];
    this.selectedConductUsers = [];
    this.selectedAuMaster = null;
    this.auData.auditProposedDate = null;
    this.selectedLeadAuditor = null;
    this.participantData.participantName = this.participantData.applicationUserId = null;
    this.showAddEditbtn = this.visibleAddButton = true;
    this.operationFlag = 'ADD';
    this.addplanStage = true;
    this.qmsService.auditEditmodeDatas = {
      usage: 'DETAILS',
    };
    this.popupopend = this.popupopend + 1;
    this.popupDataTitle.title = "Create New Plan";
    this.isFrozen = false;
    this.auData.tempAuNo = null;
    this.auData.parentPlanAuditNo = this.auData.auNo;
    this.auData.questionAndAnswerSectionType = false;

    this.freezeAnnalRefNoDropDown = false;
    this.flexibleComponent.from = 'Master';
    setTimeout(() => this.flexibleComponent.main())
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  operationFlag: any;

  addplanStage: boolean = false;
  openAddPopup(tabName: any, value: boolean) {
    this.auService.questionnaireList = [];
    this.selectedConductUsers = [];
    this.selectedAuMaster = null;
    this.addplanStage = value;
    this.showAddEditbtn = this.visibleAddButton = true;
    this.operationFlag = 'ADD';
    if (!this.addplanStage) {
      this.auData = {};
      [
        this.selectedFunctionalAreaOrServices
      ] = new Array(1).fill([]);
      [
        this.auData.annualRefNo,
        this.auData.subGroupName,
        this.auData.auditPurpose,
        this.auData.auditScope,
        this.auData.auditReferences,
        this.auData.remarks,
        this.auData.vendorId,
        this.auData.vendorName,
        this.auData.departmentId,
        this.auData.departmentName,
        this.participantData.applicationUserId,
        this.participantData.participantName,
        this.auData.status,
        this.auData.shortDescription
      ] = new Array(13).fill('');
      [
        this.selectedAuRefNo,
        this.selectedAuditType,
        this.selectedAuditCategory,

        this.selectedAuditClassification,
        this.selectedLeadAuditor,
        this.selectedScheduleApprover,
        this.selectedPlanApprover,
        this.selectedDepartment,
        this.selectedAuMaster,
        this.selectedLeadAuditor,
        this.selectedSubGroup,
        this.selectedAuditType,

        this.auData.auditProposedDate,
        this.auData.scheduleAuditProposedDate,
        this.auData.expectedToBeStartedOn,
        this.auData.expcetedClosureOn,
        this.auData.tempAuNo,
        this.auData.intimateToPlanNDaysBefore,
        this.auData.parentPlanAuditNo

      ] = new Array(18).fill(null);
      this.isAuRefNoOdd = null;
      this.isAuditCategoryOdd = null;
      this.isAuditClassificationOdd = null;
      this.isAuMasterOdd = null;
      this.isAuditTypeOdd = null;
      this.isSubGroupOdd = null;
      this.isLeadAuditorOdd = null;
      this.isPlanApproverOdd = null;
      this.isDepartmentCodeSearchOdd = null;
      this.isScheduleApproverOdd = null;

      this.auData.multiplePlans = false;
      this.auData.questionAndAnswerSectionType = false;
      this.auData.intimateToPlanNDaysBefore = null;
      this.auData.intimateToPlanNDaysBefore = null;
      if (this.qmsService.selectedGroupDetailData.isRiskCalculationReqd == 'Y') {
        this.auData.isRiskCalculationReqd = true;
      } else {
        this.auData.isRiskCalculationReqd = false;
      }
      this.auData.effectivenessCheckReqd = false;
      this.selectedPlanUsers = [];
      this.freezeAuditTypeDropDown = true;
      this.qmsService.activityId = null;
      this.displayVendor = this.displayDepartment = this.displayFunctionalAreaOrServices = this.visibleEditButton = false;
    }
    this.qmsService.auditEditmodeDatas = {
      usage: 'DETAILS',
    };
    let title;

    if (tabName == 'Annual Audit Schedule') {
      title = 'Add Annual Audit Schedule';
    } else if (tabName == 'Audit Plan') {
      title = 'Add Audit Plan';
    } else {
      title = 'Add Audit';
    }

    this.popupDataTitle.title = title;
    this.popupopend = this.popupopend + 1;
    if (this.addplanStage) {
      this.popupDataTitle.title = "Create New Plan";
    }
    this.auData.tempAuNo = null;
    this.freezeAnnalRefNoDropDown = false;

    this.primaryAuditeeList = [];
    this.isFrozen = false;
    this.appService.getQmsActiveGroupUsers(this.qmsService.selectedActivityGroupId, this.qmsService.moduleName, "Primary Auditee").subscribe((data: any) => {
      this.primaryAuditeeList = data;
    });
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  editingAuData: any;
  freezeAnnalRefNoDropDown: any = false;
  freezeSubGroupDropDown: any = false;
  showAddEditbtn: boolean;
  stageName: any;
  actionStatusOptions: any;
  instructions = "";
  buttonLabels: string[] = [];
  saveButtonForTraining: boolean = false;
  popupopend: number = 0;
  scheduleStatusHandling = [];
  defaultBtnAuditScheduleList: any = ["Re-Schedule", "Cancel Schedule", "Add New Plan", "Lock Plan", "Unlock Plan", "Initiate Plan"];
  defaultBtnAuditPlan: any = ["Re-Plan", "Cancel Plan"];
  showQuestions: boolean = false;

  openEditPopup(tabName: any, editingAuData: any, usage: any) {
    this.showQuestions = false;
    this.updateQuestionarie = null;
    this.selectedAuRefNo = null;
    this.selectedAuMaster = null;
    this.qmsService.taskModuleName = this.qmsService.moduleName;
    this.addplanStage = false;
    this.selectBoxForLeadAuditor();
    this.selectBoxForScheduleApprover();
    this.selectBoxForPlanApprover();
    this.popupopend = this.popupopend + 1;
    if (tabName == 0 && editingAuData == 0 && usage == 0) {
      tabName = this.qmsService.auditEditmodeDatas.tabName;
      editingAuData = this.qmsService.auditEditmodeDatas.editingAuData;
      usage = this.qmsService.auditEditmodeDatas.usage;
    }
    this.qmsService.auditEditmodeDatas = {
      tabName: tabName,
      editingAuData: editingAuData,
      usage: usage,
    };
    this.objForDocuments = {
      id: this.message.activityId,
      pagename: this.selectedTab == 'Audit Plan' ? "Plan" : "Schedule"
    };
    this.selectedTab = this.qmsService.auditEditmodeDatas.tabName
    this.qmsService.auditEditmodeDatas.pageName = this.qmsService.auditEditmodeDatas.tabName;
    this.qmsService.activityDynamicButtonList = [];
    if (usage == 'EDIT') {
      this.showAddEditbtn = true;
      this.visibleEditButton = true;

    } else {
      this.showAddEditbtn = false;
    }
    this.isProcessing = true;
    this.visibleAddButton = false;
    this.operationFlag = 'EDIT';
    this.editingAuData = editingAuData;
    let data = {
      status: "active"
    };
    this.appService.getOneQmsAllUsersVwDetails(data).subscribe((response: any) => {
      this.qmsUsersList = response;
    })
    this.appService.getAllAuFindingsByAuNo(this.editingAuData.AU_NO).subscribe((data: any) => {
      this.qmsService.auFindingsList = data;
    });
    this.appService.getAuByAuNo(this.editingAuData.AU_NO).subscribe((data: any) => {
      this.qmsService.activityId = this.editingAuData.AU_NO;
      this.auService.isAuditor = data.leadAuditor == this.message.getUserId();
      this.auService.isplanApprover = data.planApprover == this.message.getUserId();
      data.auditProposedDate = data.auditProposedDate ? new Date(data.auditProposedDate) : null;
      data.expcetedClosureOn = data.expcetedClosureOn ? new Date(data.expcetedClosureOn) : null;
      data.expectedToBeStartedOn = data.expectedToBeStartedOn ? new Date(data.expectedToBeStartedOn) : null;
      data.startDate = data.startDate ? new Date(data.startDate) : null;
      data.endDate = data.endDate ? new Date(data.endDate) : null;
      data.scheduleApprovalRequestedOn = data.scheduleApprovalRequestedOn ? new Date(data.scheduleApprovalRequestedOn) : null;
      data.scheduleApprovedOn = data.scheduleApprovedOn ? new Date(data.scheduleApprovedOn) : null;
      data.planApprovalRequestedOn = data.planApprovalRequestedOn ? new Date(data.planApprovalRequestedOn) : null;
      data.planApprovedOn = data.planApprovedOn ? new Date(data.planApprovedOn) : null;
      data.scheduleAuditProposedDate = data.scheduleAuditProposedDate ? new Date(data.scheduleAuditProposedDate) : null;

      this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y' && data.requestedAt && this.onRequestedAtSelect(this.event, { valueExp: data.requestedAt, displayExp: data.requestedAt });

      usage != 'EDIT' && this.dynamicbtnCall(data.status, tabName, false);

      if (!this.showAuRefNoAsTextBox && data.annualRefNo && this.dropDownForAuRefNoAndSubGroup.auditAnnualRefList) {
        const matchingAnnualRefNo = this.auRefNoDropDown.find((item: any) => item.valueExp.trim() === data.annualRefNo.trim())
        if (matchingAnnualRefNo) {
          this.selectedAuRefNo = matchingAnnualRefNo.valueExp;
          this.freezeAnnalRefNoDropDown = false;
          this.isAuRefNoOdd = null;
        } else {
          this.auRefNoDropDown.push({
            valueExp: data.annualRefNo,
            displayExp: data.annualRefNo
          });
          this.isAuRefNoOdd = this.selectedAuRefNo = data.annualRefNo;
          this.freezeAnnalRefNoDropDown = true;
        }
      } else {
        this.isAuRefNoOdd = null;
        if (data.annualRefNo == null) {
          this.selectedAuRefNo = null;
        }
        this.freezeAnnalRefNoDropDown = false;
      }

      if (this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y' && data.requestedAt) {
        const matchingRequestedAt = this.requestedAtList?.find((item: any) => item.taskRequestedAt === data.requestedAt);
        if (!matchingRequestedAt) {
          this.isRequestedAtOdd = data.requestedAt;
          this.requestedAtDropdown.push({
            valueExp: data.requestedAt,
            displayExp: data.requestedAt
          })
        }

        setTimeout(() => {
          if (this.businessAreaDropdown.length) {
            this.selectedBusinessArea = data.coreBusinessAreaName.split(',');
            this.isAllBusinessAreaSelected = this.selectedBusinessArea == this.businessAreaDropdown.length;
          } else {
            [this.selectedBusinessArea, this.isAllBusinessAreaSelected] = [[], false];
          }
        }, 1500)
      }

      if (data.auditMasterId) {
        const matchingauditMaster = this.auMasterDropDown?.find((item: any) => item.valueExp == data.auditMasterId);

        if (matchingauditMaster) {
          this.isAuMasterOdd = null;
        } else {
          this.isAuMasterOdd = data.auditMasterId;
          this.auMasterDropDown.push({
            valueExp: data.auditMasterId,
            displayExp: this.allvendorList.find((item: any) => item.auditMasterId == data.auditMasterId).description
          });
        }
        this.selectedAuMaster = data.auditMasterId;
      }

      if (data.auditCategory) {
        const matchingAuditCategory = this.auditCategoryDropDown?.find((item: any) => item.valueExp == data.auditCategory)
        if (matchingAuditCategory) {
          this.isAuditCategoryOdd = null;
        } else {
          this.auditCategoryDropDown.push({
            valueExp: data.auditCategory,
            displayExp: data.auditCategory
          });
          this.isAuditCategoryOdd = data.auditCategory;
        }
        this.selectedAuditCategory = data.auditCategory;
      }

      if (data.auditType) {
        console.log(this.dropDownForAuditType);
        this.selectedAuditType = null;
        const matchingAuditType = this.auditTypeDropDown?.find((item: any) => item.valueExp == data.auditType)
        if (matchingAuditType) {
          this.isAuditTypeOdd = null;
        } else {
          this.isAuditTypeOdd = data.auditType;
          this.auditTypeDropDown.push({
            valueExp: data.auditType,
            displayExp: data.auditType
          });
        }
        this.selectedAuditType = this.qmsService.selectedAuditType = data.auditType;
      }
      this.isProcessing = false;
      this.showQuestions = true;
      if (data.auditType?.toLowerCase().trim() == 'vendor') {
        this.displayVendor = true;
        this.displayDepartment = false;
        this.appService.getQmsVendorsVwDetailsByVendorId(data.vendorId).subscribe((vendorData: any) => {
          this.auData.vendorName = vendorData.vendorName;
          this.isProcessing = false;
          this.dropDownForFunctionalAreaOrServices = [];
          this.dropDownForFunctionalAreaOrServices = this.assignVendorFunctionalService(vendorData.servicesOffered?.split(',')) ?? [];
          this.selectBoxForFunctionalAreaOrServices();
          setTimeout(() => {
            if (data.functionalAreaOrServices) {
              let splittedValues = data.functionalAreaOrServices.split(',');
              splittedValues.forEach((element: any) => {
                if (this.functionalAreaOrServicesDropDown.includes(element)) {
                  this.functionalAreaOrServicesDropDown.push({
                    valueExp: element,
                    displayExp: element
                  });
                }
              });
              this.selectedFunctionalAreaOrServices = splittedValues;
              this.onFunctionalAreaOrServicesSelect(this.event);
            }
            this.displayFunctionalAreaOrServices = true;
          }, 500)
        })
      } else {
        this.displayDepartment = true;
        this.displayVendor = false;
        this.appService.getCodeListsByGroup('AUDIT_DEPARTMENT').subscribe((departmentData: any) => {
          const foundDepartment = departmentData?.find((department: any) => data.auditDepartment === department.codelistCode)
          if (foundDepartment) {
            this.isProcessing = false;
            this.auData.departmentName = foundDepartment.codelistName;
            this.auData.departmentId = foundDepartment.codelistCode;
            this.dropDownForFunctionalAreaOrServices = foundDepartment.subgroupValues?.split(',') ?? [];
            this.selectBoxForFunctionalAreaOrServices();
            if (data.functionalAreaOrServices) {
              let splittedValues = data.functionalAreaOrServices.split(',')
              //.map((splittedValue: any) => this.functionalAreaOrServicesDropDown.find((item: any) => item.codelistCode == splittedValue));

              splittedValues.forEach((element: any) => {
                if (this.functionalAreaOrServicesDropDown.includes(element)) {
                  this.functionalAreaOrServicesDropDown.push({
                    valueExp: element,
                    displayExp: element
                  });
                }
              });
              this.selectedFunctionalAreaOrServices = splittedValues;
              this.onFunctionalAreaOrServicesSelect(this.event);
            }
            this.displayFunctionalAreaOrServices = true;
          } else {
            this.auData.departmentName = data.deptName;
            this.auData.departmentId = data.auditDepartment;
            this.dropDownForFunctionalAreaOrServices = data.functionalAreaOrServices?.split(',') ?? [];
            this.selectBoxForFunctionalAreaOrServices();
            if (data.functionalAreaOrServices) {
              let splittedValues = data.functionalAreaOrServices.split(',')
              splittedValues.forEach((element: any) => {
                if (this.functionalAreaOrServicesDropDown.includes(element)) {
                  this.functionalAreaOrServicesDropDown.push({
                    valueExp: element,
                    displayExp: element
                  });
                }
              });

              this.selectedFunctionalAreaOrServices = splittedValues;
              this.onFunctionalAreaOrServicesSelect(this.event);
            }
            this.displayFunctionalAreaOrServices = true;
          }
        })
      }
      if (data.leadAuditor) {
        this.selectedLeadAuditor = data.leadAuditor;
        const foundDepartment = this.leadAuditorDropDown?.find((department: any) => department.valueExp === data.leadAuditor)
        if (foundDepartment) {
          this.isLeadAuditorOdd = null;
        } else {
          this.isLeadAuditorOdd = data.leadAuditor;
          this.leadAuditorDropDown.push({
            valueExp: data.leadAuditor,
            displayExp: data.leadAuditorUser
          })
        }
      } else {
        this.selectedLeadAuditor = null;
      }

      if (data.scheduleApprover) {
        this.selectedScheduleApprover = data.scheduleApprover;
        const foundDepartment = this.scheduleApproverDropDown?.find((department: any) => department.valueExp === data.scheduleApprover)
        if (foundDepartment) {
          this.isScheduleApproverOdd = null;
        } else {
          this.isScheduleApproverOdd = data.scheduleApprover;
          this.scheduleApproverDropDown.push({
            valueExp: data.scheduleApprover,
            displayExp: data.scheduleApprovedByUser
          })
        }
      }

      if (data.planApprover) {
        this.selectedPlanApprover = data.planApprover;
        const foundDepartment = this.planApproverDropDown?.find((department: any) => department.valueExp === data.planApprover)
        if (foundDepartment) {
          this.isPlanApproverOdd = null;
        } else {
          this.isPlanApproverOdd = data.planApprover;
          this.planApproverDropDown.push({
            valueExp: data.planApprover,
            displayExp: data.planApprovedByUser
          })
        }
      } else {
        this.selectedPlanApprover = null;
      }

      if (!this.showSubGroupAsTextBox && data.subGroupName && this.dropDownForAuRefNoAndSubGroup.auditSubGroupList) {
        const matchingSubGroupName = this.dropDownForAuRefNoAndSubGroup?.auditSubGroupList?.split(',').find((item: any) => item === data.subGroupName)
        if (matchingSubGroupName) {
          this.selectedSubGroup = matchingSubGroupName;
          this.isSubGroupOdd = null;
          this.freezeSubGroupDropDown = false;
        } else {
          this.subGroupDropDown.push({
            valueExp: data.subGroupName,
            displayExp: data.subGroupName
          });
          this.freezeSubGroupDropDown = true;
          this.isSubGroupOdd = data.subGroupName;
        }
        this.selectedSubGroup = data.subGroupName;
      } else {
        this.freezeSubGroupDropDown = false;
      }

      if (data.auditClassification) {
        const matchingAuditClassification = this.auditClassificationDropDown?.find((item: any) => item.valueExp == data.auditClassification)
        if (matchingAuditClassification) {
          this.isAuditClassificationOdd = null;
        } else {
          this.isAuditClassificationOdd = data.auditClassification;
          this.auditClassificationDropDown.push({
            valueExp: data.auditClassification,
            displayExp: data.auditClassification
          });
        }
        this.selectedAuditClassification = data.auditClassification;
      }

      if (data.planIntimationEmailUsers) {
        const matchingPlanUsers: [] = data.planIntimationEmailUsers?.split(',')?.map((splittedUserId: any) => this.qmsUsersList?.find((user: any) => user.userId == splittedUserId))
        if (matchingPlanUsers.length > 0) {
          this.selectedPlanUsers = matchingPlanUsers?.map((planUser: any) => ({
            userId: planUser.userId,
            userName: planUser.userName
          }))
        } else {
          this.selectedPlanUsers = [];
        }
      } else {
        this.selectedPlanUsers = [];
      }

      if (data.conductIntimationEmailUsers) {
        const matchingConductUsers: [] = data.conductIntimationEmailUsers?.split(',')?.map((splittedUserId: any) => this.qmsUsersList?.find((user: any) => user.userId == splittedUserId))
        if (matchingConductUsers.length > 0) {
          this.selectedConductUsers = matchingConductUsers?.map((conductUser: any) => ({
            userId: conductUser.userId,
            userName: conductUser.userName
          }))
        } else {
          this.selectedConductUsers = [];
        }
      } else {
        this.selectedConductUsers = [];
      }

      this.auData = data;
      this.asthetic(data);
      this.qmsService.activity = data;
      this.auData.questionAndAnswerSectionType = data.questionAndAnswerSectionType == "Y";
      this.auData.multiplePlans = data.multiplePlans == "Y";
      this.auData.isRiskCalculationReqd = data.isRiskCalculationReqd == "Y";
      this.qmsService.activity.isRiskCalculationReqd = this.auData.isRiskCalculationReqd;
      this.auData.effectivenessCheckReqd = this.qmsService.activity.effectivenessCheckReqd = data.effectivenessCheckReqd == "Y";
      this.isProcessing = false;
      this.appService.getAuParticipantsByAuNo(data.auNo).subscribe((participantResponse: any) => {
        const foundPrimaryContactData = participantResponse?.find((item: any) => item.isPrimaryContact == 'Y');
        this.isProcessing = false;
        if (foundPrimaryContactData) {
          this.participantData = foundPrimaryContactData;
          this.auService.isAuditee = this.participantData.applicationUserId == this.message.getUserId();
          this.getApplicationUserId = this.participantData.applicationUserId;
          this.getParticipantName = this.participantData.userName;
        } else {
          this.participantData = {};
          this.participantData.userName = "";
          this.participantData.applicationUserId = null;
        }

      });
      this.appService.getQmsAuQuestionsByAuNO(data.auNo).subscribe((response1: any) => {
        this.auService.questionnaireList = [];
        this.qmsService.auQuestionarie = response1;
        this.auService.questionnaireList = response1;
        this.updateQuestionarie = "Update";
      });
      this.isProcessing = false;

      if (!this.isProcessing) {
        let title;

        if (tabName == 'Annual Audit Schedule') {
          title = 'Edit Annual Audit Schedule - ' + this.auData.scheduleNo;
        } else if (tabName == 'Audit Plan') {
          title = 'Edit Audit Plan - ' + this.auData.auId;
        } else {
          title = 'Edit Audit - ' + this.auData.auId;
        }

        this.popupDataTitle.title = title;
      }
      if (this.popupopend == 1) {
        console.log(this.dialog.openDialogs.length == 0);
        if (this.dialog.openDialogs.length == 0) {
          this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
        }
      }
    })
    setTimeout(() => {
      this.functionalAreaOrServicesSelected = this.functionalAreaOrServicesDropDown.length == this.selectedFunctionalAreaOrServices.length;
      setTimeout(() => {
        this.flexibleComponent?.main();
      });
    }, 1000);
  }

  private toDate(value: any): Date | null {
    return value ? new Date(value) : null;
  }


  public handleExpectedStartChange(value: any): void {
    this.onNgModelChange(value, 'expected-start-validation');

    const start = this.toDate(value);
    const closure = this.toDate(this.auData.expcetedClosureOn);

    // Reset closure if invalid
    if (closure && start && closure < start) {
      this.auData.expcetedClosureOn = null;
    }
  }


  updateQuestionarie: any;
  buttonLabelsTemp: any = [];
  defaultbtn: boolean = false;
  statusStage: any = "";
  dynamicbtnCall(status: any, tabname: string, value: boolean) {
    this.buttonLabelsTemp = [];
    this.defaultbtn = false;


    if (this.auService.auditScheduleStatusList.includes(status)) {
      this.statusStage = 'Annual Audit Schedule';
    } else if (this.auService.auditPlanStatusList.includes(status)) {
      this.statusStage = 'Audit Plan';
    } else if (this.auService.auditConductStatusList.includes(status)) {
      this.statusStage = 'Conduct Audit';
    }

    let data1 = {

      activityId: this.message.activityId,
      moduleName: this.qmsService.moduleName,
      status: status
    }
    this.appService.getQmsButtons(data1).subscribe((data: any) => {
      this.qmsService.activitySaveButton = false;
      this.qmsService.activityDynamicButtonList = [];
      this.buttonLabels = [];
      if (data.resultType == "S") {
        this.stageName = data.stageName;
        this.actionStatusOptions = data.actionStatusOptions;
        this.instructions = data.instructions;
        this.qmsService.activityButtonLabels = data;

        if (data.buttonLabels) {
          this.buttonLabels = data.buttonLabels.split(",");
          const tempbtnlabels: any = [];
          this.qmsService.activityDynamicButtonList = this.buttonLabels;
          this.qmsService.showflexifieldshow = false;
          for (const element of this.buttonLabels) {
            if (tabname == 'Annual Audit Schedule' && (this.auService.auditPlanStatusList.includes(status) || this.auService.auditConductStatusList.includes(status))) {
              if (this.auService.specificButtonforschedule.includes(element)) {
                tempbtnlabels.push(element);
              }
            } else if (tabname == 'Annual Audit Schedule' && !this.auService.specificButtonforPlan.includes(element)) {
              tempbtnlabels.push(element);
            }
            if (tabname == 'Audit Plan' && (element.includes("Submit") || element.includes("Review") || element.includes("Approv") || element.includes("Accept"))) {
              this.qmsService.showflexifieldshow = true;
            }
            if (tabname == 'Audit Plan' && (this.auService.auditScheduleStatusList.includes(status) || this.auService.auditConductStatusList.includes(status))) {
              if ((this.auService.specificButtonforPlan.includes(element) || this.auService.auditPlanStatusList.includes(status)) && !this.auService.specificButtonforschedule.includes(element)) {
                tempbtnlabels.push(element);
              }
            } else if (tabname == 'Audit Plan' && this.auService.specificButtonforPlan.includes(element)) {
              tempbtnlabels.push(element);
            } else if (tabname == 'Audit Plan' && !this.auService.specificButtonforschedule.includes(element)) {
              tempbtnlabels.push(element);
            }
            if (element == "Save" && (this.auData.scheduleStatus != 'Scheduled' || (this.auData.scheduleStatus == 'Scheduled' && tabname != 'Annual Audit Schedule'))) {
              this.saveButtonForTraining = true;
              this.qmsService.activitySaveButton = true;
            }
          }
          this.qmsService.activityDynamicButtonList = [];
          tempbtnlabels.unshift("Cancel");
          this.qmsService.activityDynamicButtonList = tempbtnlabels;
        } else {
          this.buttonLabels.unshift("Cancel");
          this.qmsService.activityDynamicButtonList = this.buttonLabels;
        }
      } else {
        this.buttonLabels.unshift("Cancel");
        this.qmsService.activityDynamicButtonList = this.buttonLabels;
      }
      if (data.resultType != "S") {
        this.showSnackBar(data.result, data.resultType);
        this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          //duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        this.snackbarRef.onAction().subscribe(() => {
          this.snackbarRef.dismiss();
        });
      }
    })
  }

  deletingAuMasterId: any;
  openDeletePopup(tabName: any, deletingAuData: any) {
    this.operationFlag = 'DELETE';
    let title;

    if (tabName == 'Annual Audit Schedule') {
      title = 'Delete Annual Audit Schedule';
    } else if (tabName == 'Audit Plan') {
      title = 'Delete Audit Plan';
    } else {
      title = 'Delete Audit';
    }

    this.popupDataTitle.title = title; this.auData.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  isContentEmpty(content: string): boolean {
    // Create a temporary element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Get the text content and trim it
    const textContent = (tempDiv.textContent ?? tempDiv.innerText) || '';
    return textContent.trim().length === 0;
  }

  async validateAudit(): Promise<void> {
    const validations = [
      { condition: !this.auData.expectedToBeStartedOn, id: 'expected-start-validation' },
      { condition: !this.auData.expcetedClosureOn, id: 'expected-closure-validation' },
      { condition: this.selectedAuditCategory == null, id: 'category-validation' },
      { condition: this.selectedAuditType == null, id: 'type-validation' },
      { condition: this.selectedAuditClassification == null, id: 'classification-validation' },
      { condition: this.displayVendor && !this.auData.vendorId, id: 'vendor-validation' },
      { condition: this.displayDepartment && !this.auData.departmentId, id: 'department-validation' },
      { condition: !this.auData.auditProposedDate, id: 'proposed-or-schedule-validation' },
      { condition: !this.auData.shortDescription, id: 'short-description-validation' },
      /* { condition: !this.auData.requestedAt && this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y', id: 'requested-at' }, */
      { condition: (this.businessAreaDropdown.length ? !this.selectedBusinessArea.length : !this.auData.coreBusinessAreaName) && this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y' && this.auData.requestedAt, id: 'business-area' },
      { condition: this.selectedTab == 'Annual Audit Schedule' && this.selectedScheduleApprover == null, id: 'schedule-approver-validation' },
      { condition: this.selectedTab == 'Audit Plan' && this.selectedPlanApprover == null, id: 'plan-approver-validation' },
      { condition: this.selectedTab == 'Audit Plan' && !this.auData.startDate, id: 'start-date' },
      { condition: this.selectedTab == 'Audit Plan' && !this.auData.endDate, id: 'end-date' },
      { condition: this.selectedTab == 'Audit Plan' && this.selectedLeadAuditor == null, id: 'lead-auditor-validation' },
      { condition: this.selectedTab == 'Audit Plan' && !this.participantData.applicationUserId, id: 'participant-validation' },
      { condition: this.selectedTab == 'Audit Plan' && (!this.auData.auditPurpose || this.isContentEmpty(this.auData.auditPurpose)), id: 'purpose-validation' },
      { condition: this.selectedTab == 'Audit Plan' && (!this.auData.auditScope || this.isContentEmpty(this.auData.auditScope)), id: 'scope-validation' },
      { condition: this.selectedTab == 'Audit Plan' && (!this.auData.auditReferences || this.isContentEmpty(this.auData.auditReferences)), id: 'references-validation' },
      { condition: this.selectedTab == 'Audit Plan' && (!this.auData.remarks || this.isContentEmpty(this.auData.remarks)), id: 'remarks-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateQuestionnaire(): Promise<void> {
    const validations = [
      {
        condition: this.selectedTab == 'Audit Plan' && this.auData.questionAndAnswerSectionType && !this.auService.questionnaireList.length, id: 'q-validation'
      }
    ]
    await this.handleAsyncValidation(validations);
  }

  mandatoryFieldNull: boolean = false;
  flexiFieldId: any;
  async validateAuditFlexiFields(): Promise<void> {
    const validations = [];
    const x: boolean = this.selectedTab == 'Audit Plan' && this.flexibleComponent.mandatoryValidation();
    validations.push({ condition: x, id: '' });
    await this.handleAsyncValidation(validations);
  }

  private async handleAsyncValidation(validations: { condition: boolean, id: string }[]): Promise<void> {
    const invalidIds: string[] = validations.filter(v => v.condition).map(v => v.id);
    this.qmsService.validatedAuArray.push(invalidIds.length > 0 ? 'Failed' : 'Passed')
    if (invalidIds.length > 0) {
      this.manageValidations(invalidIds);
    }
    const invalidIds1: string[] = validations.filter(v => !v.condition).map(v => v.id);
    if (invalidIds1.length > 0) {
      this.managefalseValidations(invalidIds1);
    }

  }

  getFailedConditionMet(): number {
    return this.qmsService.validatedAuArray.filter((e: any) => e.includes('Failed')).length == 1 && this.selectedTab == 'Audit Plan' && this.auData.questionAndAnswerSectionType && !this.auService.questionnaireList.length;
  }

  addAndEditFunction() {
    return new Promise<boolean>((resolve) => {

      let validationPromises: Promise<void>[] = [];
      this.qmsService.validatedAuArray = [];

      if (!this.skipValidationsWhileSwitchingUser) {
        validationPromises.push(this.validateAudit());
        this.operationFlag != 'ADD' && validationPromises.push(this.validateQuestionnaire());
        this.selectedTab == 'Audit Plan' && this.flexibleComponent.flexibleFields.length > 0 && validationPromises.push(this.validateAuditFlexiFields());
      }

      Promise.all(validationPromises).then(() => {

        const isValid = !this.qmsService.validatedAuArray.includes('Failed');

        if (isValid) {

          this.isProcessing = true;

          let businessArea = null;
          if (this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y') {
            businessArea = this.businessAreaDropdown.length ? this.selectedBusinessArea?.join(',') : this.auData?.coreBusinessAreaName ?? null;
          }

          let auditObj: any = {
            groupId: this.selectedAuditGroup[0]?.valueExp ?? null,
            subGroupName: this.showSubGroupAsTextBox ? this.auData.subGroupName : this.selectedSubGroup ?? null,
            annualRefNo: this.showAuRefNoAsTextBox ? this.auData.annualRefNo : this.selectedAuRefNo ?? null,
            scheduleApprover: this.selectedScheduleApprover ?? null,
            planApprover: this.selectedPlanApprover ?? null,
            leadAuditor: this.selectedLeadAuditor ?? null,
            auditType: this.selectedAuditType ?? null,
            auditCategory: this.selectedAuditCategory ?? null,
            auditClassification: this.selectedAuditClassification ?? null,
            auditProposedDate: this.auData.auditProposedDate ? this.appService.dateZoneConvertion(new Date(this.auData.auditProposedDate)) : null,
            scheduleAuditProposedDate: this.auData.scheduleAuditProposedDate ? this.appService.dateZoneConvertion(new Date(this.auData.scheduleAuditProposedDate)) : null,
            startDate: this.auData.startDate ? this.appService.dateZoneConvertion(new Date(this.auData.startDate)) : null,
            endDate: this.auData.endDate ? this.appService.dateZoneConvertion(new Date(this.auData.endDate)) : null,
            ...(this.displayVendor && { vendorId: this.auData.vendorId }),
            ...(this.displayDepartment && { auditDepartment: this.auData.departmentId }),
            functionalAreaOrServices: this.selectedFunctionalAreaOrServices?.length ? this.selectedFunctionalAreaOrServices.join(',') : null,
            auditMasterId: this.selectedAuMaster,
            auditPurpose: this.auData.auditPurpose,
            auditScope: this.auData.auditScope,
            auditReferences: this.auData.auditReferences,
            intimateToPlanNDaysBefore: this.auData.intimateToPlanNDaysBefore ?? this.auData.intimateToPlanNDaysBefore,
            planIntimationEmailUsers: this.selectedPlanUsers?.map((planUsers: any) => planUsers.userId)?.join(","),
            intimateToConductNDaysBefore: this.auData.intimateToConductNDaysBefore,
            conductIntimationEmailUsers: this.selectedConductUsers?.map((conductUsers: any) => conductUsers.userId)?.join(","),
            remarks: this.auData.remarks,
            questionAndAnswerSectionType: this.auData.questionAndAnswerSectionType ? "Y" : "N",
            multiplePlans: this.auData.multiplePlans ? "Y" : "N",
            isRiskCalculationReqd: this.auData.isRiskCalculationReqd ? "Y" : "N",
            effectivenessCheckReqd: this.auData.effectivenessCheckReqd ? "Y" : "N",
            expectedToBeStartedOn: this.auData.expectedToBeStartedOn ? this.appService.dateZoneConvertion(new Date(this.auData.expectedToBeStartedOn)) : null,
            expcetedClosureOn: this.auData.expcetedClosureOn ? this.appService.dateZoneConvertion(new Date(this.auData.expcetedClosureOn)) : null,
            pageName: this.selectedTab == 'Annual Audit Schedule' ? 'Schedule' : 'Plan',
            planCreatedFromAuNo: this.addplanStage ? this.qmsService.activityId : null,
            tempAuNo: this.auData.tempAuNo ?? null,
            shortDescription: this.auData.shortDescription,
            requestedAt: this.dynamicLabel['REQUESTED_AT']?.isRemovable == 'Y' ? null : this.auData.requestedAt,
            coreBusinessAreaName: this.dynamicLabel['REQUESTED_AT']?.isRemovable == 'Y' ? null : businessArea,
            parentPlanAuditNo: this.auData.parentPlanAuditNo ? this.auData.parentPlanAuditNo : null,
          }

          if (this.addplanStage) {
            auditObj.pageName = 'New Plan';
          }
          this.execute(auditObj);
        } else {
          this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
        }
      }).catch((error) => {
        console.error('Error occurred during validation:', error);
        resolve(false);
      })
    })
  }

  private clearCalenderNavigation(): void {
    if (this.coreNavigationService.calenderNavigation) {
      this.coreNavigationService.calenderNavigation = '';
    }
  }

  @ViewChild('flexible', { static: false }) flexibleComponent!: FlexibleFieldsComponent;
  execute(auditObj: any) {
    if (this.operationFlag == 'ADD') {
      this.appService.createAu(auditObj).subscribe({
        next: (Response: any) => {
          this.message.lastmsg = Response;
          if (Response.resultType == "S") {
            this.popupopend = 0;

            this.editingAuData = {
              "AU_NO": Response.generatedAuditNo,
              "TEMP_AU_NO": null,
              "AU_ID": null
            };

            this.qmsService.activityId = Response.generatedAuditNo;
            this.isProcessing = false;
            this.visibleAddAndEditPopup?.close();
            this.clearCalenderNavigation();
            this.participantData.participantId = undefined;

            if (this.selectedTab == 'Audit Plan') {
              this.participantSave(auditObj);
            } else {
              this.getCall();
              this.getChartCounts();
              this.showSnackBar(Response.result, Response.resultType);
            }

            if (this.flexibleComponent?.flexibleFields.length) {
              this.flexibleComponent.save('Master', +Response.generatedAuditNo);
            }

          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    } else {
      this.editingAuData.TEMP_AU_NO = this.auData.tempAuNo;

      const modifiedAuditObj = {
        ...auditObj,
        tempAuNo: this.editingAuData.TEMP_AU_NO,
        auNo: this.editingAuData.AU_NO,
        auId: this.auData.auId,
      }

      this.appService.updateAu(modifiedAuditObj).subscribe({
        next: (Response: any) => {
          this.qmsService.auditEditmodeDatas.pageName = '';
          this.message.lastmsg = Response;
          if (Response.resultType == "S") {
            if (!this.qmsService.isUpdatingAuThroughDynBtn) {
              this.isProcessing = false;
              this.visibleAddAndEditPopup?.close();
              this.clearCalenderNavigation();
              this.popupopend = 0;
            }

            if (this.selectedTab == 'Audit Plan') {
              this.participantSave(auditObj);
            } else {
              this.getCall();
              this.getChartCounts();
              !this.qmsService.isUpdatingAuThroughDynBtn && (this.showSnackBar(Response.result, Response.resultType));
              this.qmsService.isUpdatingAuThroughDynBtn && (this.qmsService.isUpdatingAuThroughDynBtn = false);
            }

            if (this.skipValidationsWhileSwitchingUser) {
              this.skipValidationsWhileSwitchingUser = false;
            } else if (this.selectedTab == 'Audit Plan' && this.flexibleComponent?.flexibleFields.length) {
              this.flexibleComponent.save('activity', this.qmsService.activityId);
            }
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    }
  }

  participantSave(auditObj: any) {
    let participantObj = {
      role: this.displayDepartment ? "Auditee" : "Vendor",
      participantName: this.participantData.participantName,
      applicationUserId: this.participantData.applicationUserId,
      isApplicationUser: "Y",
      isPrimaryContact: "Y",
      sendNotifications: "Y"
    }

    const modifiedAuditObj = {
      ...auditObj,
      ...participantObj,
      tempAuNo: this.editingAuData.TEMP_AU_NO,
      auNo: this.editingAuData.AU_NO,
      auId: this.editingAuData.AU_ID,
    }
    if (this.participantData.participantId == undefined) {
      this.appService.createQmsAuParticipant(modifiedAuditObj).subscribe({
        next: (ParticipantResponse: any) => {
          if (ParticipantResponse.resultType == 'S') {
            this.isProcessing = false;
            this.getCall();
            this.getChartCounts();
            if (this.selectedTab == 'Audit Plan' && this.flexibleComponent.flexibleFields.length) {
              this.flexibleComponent.save('activity', this.qmsService.activityId);
            }
            this.qmsService.auditEditmodeDatas.pageName = '';
            if (this.qmsService.isUpdatingAuThroughDynBtn) {
              this.qmsService.isUpdatingAuThroughDynBtn = false
            } else {
              this.visibleAddAndEditPopup.close();
            }
            this.clearCalenderNavigation();
            this.popupopend = 0;
          } else {
            this.isProcessing = false;
            this.showSnackBar(ParticipantResponse.result, ParticipantResponse.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    } else {
      const modifiedParticipantObj = {
        ...participantObj,
        ...this.participantData,
        participantId: this.participantData.participantId,
      }
      this.appService.updateQmsAuParticipant(modifiedParticipantObj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getCall();
            this.getChartCounts();
          } else {
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    }
  }

  cancelAddAndEditFunction() {
    this.isProcessing = false;
    if (this.coreNavigationService.navigationSource == 'Home') {
      this.qmsService.auditEditmodeDatas.pageName = '';
      this.visibleAddAndEditPopup.close();
      this.clearCalenderNavigation();
      this.popupopend = 0;
      this.coreNavigationService.navigationSource = '';
      this.router.navigate(['dashboard']);
    } else if (this.auService.auditPageFrom == "MyTask") {
      if (this.qmsService.auditEditmodeDatas.pageName == "Conduct Audit") {
        this.message.showLeftMenu = "Main";
        this.auService.tabName = null;
        this.qmsService.taskModuleName = null;
        this.qmsService.auditEditmodeDatas.pageName = null;
        this.router.navigate(['dashboard/MyTasks']);

      } else {
        this.qmsService.auditEditmodeDatas.pageName = '';
        this.visibleAddAndEditPopup.close();
        this.clearCalenderNavigation();
        this.popupopend = 0;
      }
    } else {
      this.qmsService.auditEditmodeDatas.pageName = '';
      this.visibleAddAndEditPopup.close();
      this.clearCalenderNavigation();
      this.popupopend = 0;
    }
  }

  deleteFunction(auMasterData: any) {
    /* Delete funtion goes here */
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    if (field != null)
      field.style.color = items ? '#005c8a' : 'red';
  }

  handleDropDownValidation(fieldId: string, selectedItems: any) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    if (field != null)
      field.style.color = selectedItems === null && field ? 'red' : '#005c8a';
  }

  manageValidations(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      if (elementId) {
        const element = document.getElementById(elementId) as HTMLInputElement;
        element && (element.style.color = 'red');
      }
    })
  }

  managefalseValidations(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      if (elementId) {
        const element = document.getElementById(elementId) as HTMLInputElement;
        if (element) {
          element.style.color = '#005c8a';
        }
      }
    })
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  totalNumberOfData: any = [];
  getListOfGridChartCountsDetails: any = [];
  selectedTab: string | undefined;
  onTabChanged($event: any) {
    this.isProcessing = true;
    this.selectedTab = $event.tab.textLabel;
    this.auService.tabName = this.selectedTab;
    this.choosedFilter = {
      filterCondition: "",
      filterName: "None",
      filterSeq: 0,
      isActive: "",
      pageName: "",
      serviceRequestReference: "",
      usedAsAppend: ""
    };
    this.getChartCounts();
    this.hightSection = 'Active';
    let gridName;

    if (this.selectedTab == 'Annual Audit Schedule') {
      gridName = 'AU_SCHEDULE';
    } else if (this.selectedTab == 'Audit Plan') {
      gridName = 'AU_PLAN';
    } else {
      gridName = 'AU_CONDUCT';
    }

    this.appService.getgridfilters(gridName).subscribe((data: any) => {
      this.filterList = data;
    })

  }
  getChartCounts() {
    let moduleName;

    if (this.selectedTab == 'Annual Audit Schedule') {
      moduleName = 'AU-SCHEDULE';
    } else if (this.selectedTab == 'Audit Plan') {
      moduleName = 'AU-PLAN';
    } else {
      moduleName = 'AU-CONDUCT';
    }

    let data = {

      module: moduleName,
      groupId: this.qmsService.selectedActivityGroupId
    };

    this.appService.getGridChartCountsDetails(data).subscribe((chartData: any) => {
      this.getListOfGridChartCountsDetails = [];
      if (this.selectedTab != 'Conduct Audit') {
        delete chartData[0].myActive;
        delete chartData[0].myOverdue;
        delete chartData[0].myTotal;
      }
      const keys = Object.keys(chartData[0]);

      const statusMapping: {
        [key: string]: {
          id: number;
          status: string;
          colorCode: string;
        };
      } = {
        total: { id: 101, status: 'Total', colorCode: '#0080FF' },
        closed: { id: 102, status: 'Closed', colorCode: '#009C40' },
        active: { id: 103, status: 'Active', colorCode: '#ECFF00' },
        others: { id: 104, status: 'Others', colorCode: '#9D97FF' },
        overdue: { id: 105, status: 'Overdue', colorCode: '#FF0000' },
        myTotal: { id: 106, status: 'My Total', colorCode: '#FF00FB' },
        myActive: { id: 107, status: 'My Active', colorCode: '#FF00FB' },
        myOverdue: { id: 108, status: 'My Overdue', colorCode: '#FF00FB' }
      };

      for (const key of keys) {
        if (statusMapping[key]) {
          this.getListOfGridChartCountsDetails.push({
            ...(statusMapping[key] as { id: any; status: string; colorCode: string }), // Type assertion
            count: chartData[0][key] ?? 0,
          });
        }
      }

      this.totalNumberOfData = this.getListOfGridChartCountsDetails.filter((x: any) => x.status === 'Total');
      for (const item of this.getListOfGridChartCountsDetails) {
        if (item.status !== 'Total') {
          if (item.count && item.count > 0 && this.totalNumberOfData[0]?.count && this.totalNumberOfData[0].count > 0) {
            item.percentage = Math.round((item.count / this.totalNumberOfData[0].count) * 100);
          } else {
            item.percentage = 0;
          }
        }
        if (!item.count) {
          item.count = 0;
        }
      }

      this.getListOfGridChartCountsDetails.sort((a: any, b: any) => a.id - b.id);
      console.log('Chat Data - ', this.getListOfGridChartCountsDetails);

      // Initialization of Active Chart.
      setTimeout(() => {
        this.preIdAttibute = '';
        const getInitialActiveValue = this.getListOfGridChartCountsDetails.find((x: any) => x.status === 'Active');
        if (this.qmsService.activity) {
          this.qmsService.activity.chartStatus = getInitialActiveValue.status;
        } else {
          this.qmsService.activity = { chartStatus: getInitialActiveValue.status };
        }
        this.onClickOnChart(getInitialActiveValue.id, getInitialActiveValue);
      }, 1000);

    })
  }

  currentIdAttibute: any;
  preIdAttibute: any = '';
  styleMiniChartContainer: any;
  onClickOnChart(event: any, data: any) {
    this.isProcessing = true;
    if (this.preIdAttibute != '') {
      this.styleMiniChartContainer = document.getElementById(this.preIdAttibute) as HTMLInputElement;
      this.styleMiniChartContainer.style.boxShadow = '';
    }


    if (event.currentTarget) {
      this.currentIdAttibute = event.currentTarget.id;
      this.preIdAttibute = event.currentTarget.id;
      if (this.qmsService.activity) {
        this.qmsService.activity.chartStatus = data.status;
      } else {
        this.qmsService.activity = { chartStatus: data.status };
      }
    } else {
      this.currentIdAttibute = "" + event + "";
      this.preIdAttibute = "" + event + "";
    }

    this.styleMiniChartContainer = document.getElementById(this.currentIdAttibute) as HTMLInputElement;
    this.hightSection = data.status;
    this.isProcessing = false;
    this.getCall();
  }
  hightSection: any;

  choosedFilter = {
    filterCondition: "",
    filterName: "None",
    filterSeq: 0,
    isActive: "",
    pageName: "",
    serviceRequestReference: "",
    usedAsAppend: ""
  };

  filterMethodClicked(item: any) {

    if (item == null) {
      this.choosedFilter = {
        filterCondition: "",
        filterName: "None",
        filterSeq: 0,
        isActive: "",
        pageName: "",
        serviceRequestReference: "",
        usedAsAppend: ""
      };
      this.getCall();
    } else {
      this.choosedFilter = item;

      if (this.choosedFilter.usedAsAppend == "N") {
        this.preIdAttibute = '';
        const getInitialActiveValue = this.getListOfGridChartCountsDetails.find((x: any) => x.status === 'Total');
        this.qmsService.activity.chartStatus = getInitialActiveValue.status;
        this.onClickOnChart(getInitialActiveValue.id, getInitialActiveValue);
      } else {
        this.getCall();
      }
    }
  }

  refreshGridData() {
    this.isProcessing = true;
    this.getCall();
    this.getChartCounts();
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  auMasterDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  getCall() {
    this.isProcessing = true;
    if (this.selectedAuditGroup.length == 0) {
      alert("Please select the group");
      this.isProcessing = false;
    } else {
      this.qmsService.auFindingsList = [];
      let gridName;

      if (this.selectedTab == 'Annual Audit Schedule') {
        gridName = 'AU_SCHEDULE';
      } else if (this.selectedTab == 'Audit Plan') {
        gridName = 'AU_PLAN';
      } else {
        gridName = 'AU_CONDUCT';
      }

      this.qmsService.selectedGroup = this.selectedAuditGroup[0].valueExp.toString();

      const data = {
        gridName: gridName,
        groupId: this.selectedTab == 'Annual Audit Schedule' ? 0 : this.qmsService.selectedGroup,
      }
      this.appService.getDynamicGridHeaders(data).subscribe({
        next: (response: any) => {
          response.orderByClause = response.orderByClause ? response.orderByClause : "";
          this.makeStickyColumns = response.fixedFieldCnt;

          const data1: any = {

            gridName: "QMS_AU_VW",
            tableOrViewName: response.tableOrViewName || "",
            columnsList: response.columnsList || "",
            fieldLabelsList: response.fieldLabelsList || "",
            invisibleColumn: response.invisibleColumn || "",
            orderByClause: response.orderByClause || "",
            fieldSizeList: response.fieldSizeList || "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            manualEntryDataFields: response.manualEntryDataFields,
            groupId: this.selectedAuditGroup[0]?.valueExp.toString() || null,
            chartStatus: this.qmsService.activity.chartStatus,
            clobColumnlist: response.closblist || "",
            blobColumnlist: response.bloblist || "",
            usedAsAppend: this.choosedFilter.usedAsAppend,
            filterCondition: this.choosedFilter.filterCondition
          };

          this.reportObj = { ...data1, ...data };

          this.appService.getDynamicGridData(data1).subscribe({
            next: (response1: any) => {
              this.auMasterDataForGrid = response1;

              data1.columnsListarray = data1.columnsList.split(",");
              data1.fieldColumnarray = data1.fieldLabelsList.split(",");
              data1.invisibleColumnarray = data1.invisibleColumn.split(",");
              data1.fieldSizeListArray = data1.fieldSizeList.split(",");

              this.columnLists.columnsListarray = data1.columnsListarray;
              this.columnLists.fieldLabelsList = data1.fieldLabelsList;
              this.columnLists.fieldColumnarray = [];

              for (let p = 0; p < data1.fieldColumnarray.length; p++) {
                this.columnLists.fieldColumnarray.push({
                  fieldColumnarray: data1.fieldColumnarray[p],
                  width: data1.fieldSizeListArray[p] + 'px'
                });
              }

              this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
              this.columnLists.fieldSizeListArray = [];

              for (const element of data1.fieldSizeListArray) {
                this.columnLists.fieldSizeListArray.push(element + 'px');
              }

              for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
                for (const element of this.columnLists.invisibleColumnarray) {
                  if (this.columnLists.columnsListarray[y] == element) {
                    this.columnLists.columnsListarray.splice(y, 1);
                    this.columnLists.fieldColumnarray.splice(y, 1);
                    this.columnLists.fieldSizeListArray.splice(y, 1);
                  }
                }
              }

              let tableData = {
                tablename: data1.tableOrViewName
              };

              this.columnLists.columnsListarray1 = [];
              this.reportObj = { ...data1, ...data };

              this.appService.tableFieldsDataType(tableData).subscribe({
                next: (response2: any) => {
                  this.dataTypeList = response2;
                  this.columnLists.columnsListarray1 = [];

                  for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                    this.columnLists.columnsListarray1.push({});
                    this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                    this.columnLists.columnsListarray1[m].dataType = "textbox";
                    this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;

                    for (const element of this.dataTypeList) {
                      if (element.columnName == this.columnLists.columnsListarray[m]) {
                        this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                      }
                    }
                  }

                  for (const row of this.auMasterDataForGrid) {
                    for (const element of this.dataTypeList) {
                      if (element.fieldType == 'CHECKBOX') {
                        row[element.columnName] =
                          row[element.columnName] == "Y" ? true : row[element.columnName];
                      }
                    }
                  }

                  this.calculateTotalPages = this.collectionSize / this.perPage;
                  this.pager.totalPages = undefined;
                  this.setPage(1, 0);
                  this.labelCall();
                  this.isProcessing = false;
                },
                error: (error) => {
                  this.isProcessing = false;
                  throw error;
                }
              });

              this.message.gridList = this.auMasterDataForGrid;
              this.collectionSize = this.auMasterDataForGrid.length;
              this.totalPages = Math.ceil(this.auMasterDataForGrid.length / this.itemsPerPage);
            },
            error: (error) => {
              this.isProcessing = false;
              throw error;
            }
          });
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
    setTimeout(() => {
      this.appService.getQmsReportTemplateDetailsByModuleAndGroupId("AU", this.qmsService.selectedActivityGroupId).subscribe((responsess: any) => {
        this.dropDownDataForReportTemplate = [];
        this.dropDownDataForReportTemplate = responsess;
        this.selectBoxForReportTemplate();

      });
      this.isProcessing = false;
    }, 3000);
  }
  label: any = [];
  dynamicLabel: any = null;
  labelCall() {
    this.label = [];
    this.dynamicLabel = null;
    let gridName;
    let tableName;
    let groupId;

    if (this.selectedTab == 'Annual Audit Schedule') {
      gridName = 'AU_SCHEDULE';
      groupId = 0;
    } else if (this.selectedTab == 'Audit Plan') {
      gridName = 'AU_PLAN';
      groupId = this.qmsService.selectedGroup;
    } else {
      gridName = 'AU_CONDUCT';
      groupId = this.qmsService.selectedGroup;
    }

    if (this.reportObj.tableOrViewName) {
      tableName = this.reportObj.tableOrViewName;
    } else if (this.selectedTab == 'Annual Audit Schedule') {
      tableName = 'QMS_AU_SCHEDULE_VW';
    } else if (this.selectedTab == 'Audit Plan') {
      tableName = 'QMS_AU_PLAN_VW';
    } else {
      tableName = 'QMS_AU_CONDUCT_VW';
    }

    let data = {
      gridName: gridName,
      tableName: tableName,
      moduleName: this.qmsService.moduleName,
      groupId: groupId,
      forLabel: "Y"
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          this.qmsService.activityDynamicLabel = acc;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.auMasterDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.auMasterDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.auMasterDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.auMasterDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.auMasterDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {

    this.counter = 0;
    if (e.target.checked) {
      this.visibleAuditTrail = true;
      this.childCheckBoxs = true;
      for (const element of this.auMasterDataForGrid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      this.visibleAuditTrail = false;
      for (const element of this.auMasterDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  counter: number = 0;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.AU_NO;
    } else {
      list.childCheckBoxs = false;
    }
    const filteredData = this.auMasterDataForGrid.filter((data: any) => data.childCheckBoxs !== undefined);
    this.visibleAuditTrail = filteredData.filter((data: any) => data.childCheckBoxs).length;
  }

  config: EditorConfig = {
    buttons: [],
  };

  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };
  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string, icon: string): void {

    const editorTitleMapping: Record<string, any> = {
      'Audit Purpose': this.dynamicLabel?.['AUDIT_PURPOSE']?.fieldName,
      'Audit Scope': this.dynamicLabel?.['AUDIT_SCOPE']?.fieldName,
      'Audit References': this.dynamicLabel?.['AUDIT_REFERENCES']?.fieldName,
      'Remarks': this.dynamicLabel?.['REMARKS']?.fieldName,
    };


    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.auData[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.auData[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };

  auSwitch: {} /* This obj is used to close and reopen the popup while switching the user */
  detailsData(list: any, index: any) {
    if (index == 0) {
      this.qmsService.auditEditmodeDatas = { pageName: this.selectedTab };
      this.message.activityId = this.qmsService.activityId = list.AU_NO;
      console.log(list.AU_NO);

      this.qmsService.selectedActivityGroupId = list.GROUP_ID;
      this.qmsService.activity = {};
      this.qmsService.activity.status = list.STATUS;
      this.qmsService.getQmsActionDataUsingById = {};
      this.auService.questionnaireList = [];
      this.selectedConductUsers = [];
      this.message.breadcrumbData.fourthLevel = list.AU_ID;
      if (this.qmsService.auditEditmodeDatas.pageName == 'Annual Audit Schedule') {
        this.openEditPopup(this.selectedTab, list, 'DETAILS');
      } else if (this.qmsService.auditEditmodeDatas.pageName == 'Audit Plan') {
        this.openEditPopup(this.selectedTab, list, 'DETAILS');
      } else if (this.qmsService.auditEditmodeDatas.pageName == 'Conduct Audit') {
        this.qmsService.activityDynamicButtonList = [];
        this.coreNavigationService.navigationSource = 'Conduct Audit';
        this.router.navigate(['dashboard/auDetailPage']);
      }
    }
  }

  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('auditeeAlertPopup', { static: true }) auditeeAlertPopup: TemplateRef<any>;
  visibleAuditeeAlertPopup: MatDialogRef<TemplateRef<any>>;

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  auditeeAlertPopupConfig = {
    width: '550px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  closeAuditeeAlertPopup() {
    this.visibleAuditeeAlertPopup.close();
  }


  dropDownForDesignation: any = [];
  designationListDropdown: any = [];
  departmentListDropdown: any = [];

  selectBoxForDesignation() {
    this.designationListDropdown = [];
    this.designationListDropdown = this.dropDownForDesignation?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) ?? []
  }

  selectBoxForDepartment() {
    this.departmentListDropdown = [];
    this.departmentListDropdown = this.dropDownForDepartment?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) ?? []
  }

  @ViewChild('searchUsersPopup', { static: true }) searchUsersPopup: TemplateRef<any>;
  visibleSearchUsersPopup: MatDialogRef<TemplateRef<any>>;

  searchUsersPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  qmsUsersList: any = [];
  tempPlanUsers: any = [];
  selectedPlanUsers: any = [];
  tempConductUsers: any = [];
  selectedConductUsers: any = [];
  showUserSearchGrid: boolean;
  searchByEmail: any;
  searchUserParentCheckBox: boolean = false;
  currentIndex: any;
  previousIndex: any = null;
  dealingWith: any;
  opensSearchUsersPopup(dealingWith: any) {
    this.dealingWith = dealingWith;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByEmail = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.tempPlanUsers = [];
    this.tempConductUsers = [];
    this.popupTitle = "Search User(s)";
    this.visibleSearchUsersPopup = this.dialog.open(this.searchUsersPopup, this.searchUsersPopupConfig);
  }

  resetSearchUsers() {
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByEmail = null;
    this.searchByDesignationCode = [];
    this.searchByDepartmentCode = [];
    this.tempPlanUsers = [];
    this.tempConductUsers = [];
    this.showUserSearchGrid = false;
  }

  getUsers() {
    if (this.dealingWith === 'Plan') {
      this.selectedPlanUsers = [...this.selectedPlanUsers, ...this.tempPlanUsers];
    } else {
      this.selectedConductUsers = [...this.selectedConductUsers, ...this.tempConductUsers];
    }
    this.visibleSearchUsersPopup.close();
  }

  cancelSearchUsersPopup() {
    this.visibleSearchUsersPopup.close();
  }

  searchUsersFunc() {
    this.isProcessing = true;
    let data = {
      userName: this.searchByUserName ? this.searchByUserName.toUpperCase() : "",
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      emailAddress: this.searchByEmail,
      designationCode: this.searchByDesignationCode ?? null,
      departmentCode: this.searchByDepartmentCode ?? null,
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(data).subscribe((response: any) => {
      this.qmsUsersList = response;
      this.qmsUsersList.sort((a: any, b: any) => a.userName.localeCompare(b.userName));
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  onParentCheckBoxChanged(e: any) {
    if (this.dealingWith == 'Plan') {
      this.tempPlanUsers = [];
    } else {
      this.tempConductUsers = [];
    }
    if (e.target.checked) {
      this.onParentChecked();
    } else {
      this.onParentUnChecked();
    }
  }

  onParentChecked() {
    this.qmsUsersList.every((user: any) => {
      if (user.emailAddress) {
        user.searchUserChildCheckBox = true;
        this[this.dealingWith === 'Plan' ? 'tempPlanUsers' : 'tempConductUsers'].push({ userId: user.userId, userName: user.userName });
      }
      return true;
    })
  }

  onParentUnChecked() {
    this.qmsUsersList.every((user: any) => {
      user.searchUserChildCheckBox = false;
      return true;
    })
  }

  onChildCheckBoxChanged(e: any, childData: any, idx: any) {
    if (e.target.checked) {
      childData.searchUserChildCheckBox = true;
      this.onChildChecked(childData);
    } else {
      childData.searchUserChildCheckBox = this.searchUserParentCheckBox = false;
      this.onChildUnchecked(childData);
    }
  }

  onChildChecked(checkedUser: any) {
    if (this.dealingWith == "Plan") {
      if (!this.selectedPlanUsers?.some((user: any) => user.userId === checkedUser.userId)) {
        this.tempPlanUsers.push({
          userId: checkedUser.userId,
          userName: checkedUser.userName
        })
      }
    } else if (!this.selectedConductUsers?.some((user: any) => user.userId === checkedUser.userId)) {
      this.tempConductUsers.push({
        userId: checkedUser.userId,
        userName: checkedUser.userName
      })
    }
    if (this.qmsUsersList.every((allUsers: any) => allUsers.searchUserChildCheckBox)) {
      this.searchUserParentCheckBox = true;
    }
  }

  onChildUnchecked(uncheckedUser: any) {
    if (this.dealingWith == "Plan") {
      const removal = this.tempPlanUsers?.findIndex((removableUser: any) => removableUser.userId == uncheckedUser.userId);
      if (removal > -1) this.tempPlanUsers?.splice(removal, 1);
    } else {
      const removal = this.tempConductUsers?.findIndex((removableUser: any) => removableUser.userId == uncheckedUser.userId);
      if (removal > -1) this.tempConductUsers?.splice(removal, 1);
    }
  }

  onUserRemoved(index: any) {
    if (index >= 0) this[this.dealingWith === 'Plan' ? 'selectedPlanUsers' : 'selectedConductUsers'].splice(index, 1);
  }

  removeAllUsers() {
    this[this.dealingWith === 'Plan' ? 'selectedPlanUsers' : 'selectedConductUsers'] = [];
  }

  @ViewChild(SwitchuserComponent) switchuserComponent!: SwitchuserComponent;
  openswitchuser(value: any) {
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = null;
    this.message.switchuserRole = value;
    if (value == "LeadAuditor") {
      this.message.switchedUser = this.selectedLeadAuditor;
      this.auService.selectedLeadAuditor = this.selectedLeadAuditor;
      this.message.switchUserCurrentValue = this.selectedLeadAuditor;
      this.message.switchUserdropDownList = this.leadAuditorDropDown.filter((auditor: any) => auditor.valueExp != this.participantData.applicationUserId).map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (value == "ScheduleApprover") {
      this.message.switchedUser = this.selectedScheduleApprover;
      this.auService.selectedScheduleApprover = this.selectedScheduleApprover;
      this.message.switchUserCurrentValue = this.selectedScheduleApprover;
      this.message.switchUserdropDownList = this.scheduleApproverDropDown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (value == "PlanApprover") {
      this.message.switchedUser = this.selectedPlanApprover;
      this.auService.selectedPlanApprover = this.selectedPlanApprover;
      this.message.switchUserCurrentValue = this.selectedPlanApprover;
      this.message.switchUserdropDownList = this.planApproverDropDown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    }
    this.switchuserComponent.openswitchuser(value, "AU");
  };

  onChildValueEmitted() {
    if (this.message.switchuserRole == "LeadAuditor") {
      this.selectedLeadAuditor = this.message.switchedUser;
    }
    else if (this.message.switchuserRole == "ScheduleApprover") {
      this.selectedScheduleApprover = this.message.switchedUser;
    }
    else if (this.message.switchuserRole == "PlanApprover") {
      this.selectedPlanApprover = this.message.switchedUser;
    }
    this.skipValidationsWhileSwitchingUser = true;
    this.switchuserComponent.saveMethod();
    this.switchuserComponent.visibleswitchUserPopup.close();
    this.switchuserComponent.visibleConfirmationPopup.close();
    this.addAndEditFunction();
  }

  numberValidation(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '.', '+'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  @ViewChild(ActivityAuTrailComponent) activityAuTrailComponent!: ActivityAuTrailComponent;
  openAuditTrail(type: any, activity: any) {
    activity.selectedTab = this.selectedTab;
    this.activityAuTrailComponent.openAuditTrail(activity);
  }

  /*   @ViewChild(TopNavigationComponent) topNavigationComponent!: TopNavigationComponent; */

  topNavigationComponent: any;
  openGroupMethod() {
    this.topNavigationComponent?.opengroupPopup();
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReportPopup(reportType: string) {
    console.log("this.reportObj=", this.reportObj.groupId);
    this.reportObj.groupId = this.selectedAuditGroup[0]?.valueExp.toString();
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: false };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.auService.tabName;
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);

  }

  @ViewChild('viwerClobPopup', { static: true }) viwerClobPopup: TemplateRef<any>;
  visibleviwerClobPopup: MatDialogRef<TemplateRef<any>>;
  aviwerlPopupConfig = {
    width: '80%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: 'QMS_AU_VW',
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      },
      error: (error: any) => {
        console.log(error);
        throw error;
      }
    });
    this.isProcessing = false;

  }
  htmlContent: any;
  closeHtmlContent() {
    this.visibleviwerClobPopup.close();
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    let auditType: string;

    if (this.selectedTab === 'Annual Audit Schedule') {
      auditType = 'AU_SCHEDULE';
    } else if (this.selectedTab === 'Audit Plan') {
      auditType = 'AU_PLAN';
    } else {
      auditType = 'AU_CONDUCT';
    }

    this.gridReorderComponent.reordercall(
      auditType,
      this.reportObj.tableOrViewName,
      this.qmsService.moduleName,
      this.selectedTab === 'Annual Audit Schedule' ? 0 : this.qmsService.selectedGroup
    );
  }

  onChildValueEmittedMethod() {
    this.getCall();
  };

  onFunctionalAreaSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.functionalAreaOrServicesSelected = this.functionalAreaOrServicesDropDown.length == this.selectedFunctionalAreaOrServices.length;
      })
    }
  }

  scheduler: any = [];
  planner: any = [];

  selectBoxForScheduler() {
    this.scheduler = [];
    this.scheduler = this.dropdownForSchedulers?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    })) ?? []
  }

  selectBoxForPlanner() {
    this.planner = [];
    this.planner = this.dropdownForPlanners?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    })) ?? []
  }

  isFrozen: boolean = false;
  eliteAccess: boolean = false;
  asthetic(au: any) {
    /* This function determines whether the field should be disabled based on userrole, status and business logic */
    const loggedUserId = this.message.getUserId();
    const scheduler_in_group = this.dropdownForSchedulers?.find((scheduler: any) => scheduler.userId == +loggedUserId!); /* scheduler in group */
    const planner_in_group = this.dropdownForPlanners?.find((planner: any) => planner.userId == +loggedUserId!); /* planner in group */
    const status = au.status;/* audit status */

    if (this.selectedTab == 'Annual Audit Schedule') {
      if (['Draft(Schedule)', 'Schedule Rejected', 'Re-Draft(Schedule)'].includes(status)) {
        this.isFrozen = (scheduler_in_group ? scheduler_in_group.userId : 0) != +loggedUserId!;
      } else {
        this.isFrozen = true;
      }
    } else if (this.selectedTab == 'Audit Plan') {
      if (['Draft(Plan)', 'Plan Created', 'Plan Rejected', 'Re-Draft(Plan)'].includes(status)) {
        this.isFrozen = (planner_in_group ? planner_in_group.userId : 0) != +loggedUserId!;
      } else {
        this.isFrozen = true;
      }
    }
  }
  reportName: any;
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();

    this.selectedColumns = "";
  }
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;

  isSaveReport: boolean = false;

  // Export Report
  @ViewChild('openExportReportPopup', { static: true }) openExportReportPopup: TemplateRef<any>;
  visibleExportReportPopup: MatDialogRef<TemplateRef<any>>;

  exportReportPopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  dropDownDataForReportTemplate: any;
  selectedReportTemplateValue: any = null;
  reportTemplateDropdown: any = [];
  selectBoxForReportTemplate() {

    setTimeout(() => {

      this.reportTemplateDropdown = [];
      for (const element of this.dropDownDataForReportTemplate) {
        if ((this.selectedTab == 'Annual Audit Schedule' && element.subModule == 'AU-Schedule') || (this.selectedTab == 'Audit Plan' && element.subModule == 'AU-PLAN')) {
          this.reportTemplateDropdown = this.reportTemplateDropdown.concat({
            valueExp: element.qmsReportTemplateVwPk.templateId,
            displayExp: element.templateName
          });
          if (element.isDefault == 'Y') {
            this.selectedReportTemplateValue = element.qmsReportTemplateVwPk.templateId;
          }
        }
      }
    }, 1000)
  }

  templateid: number;
  pdfDetailSearchText: string = '';
  onPdfDetailValueSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.templateid = item;
      this.selectedReportTemplateValue = item.valueExp;
      if (this.reportTemplateFieldValidation != undefined) {
        this.reportTemplateFieldValidation.style.color = '#005c8a';
      }
    }
  }

  openHeadReportPopup() {

    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    setTimeout(() => {
      this.visibleExportReportPopup = this.dialog.open(this.openExportReportPopup, this.exportReportPopupConfig);
    }, 1000)

    this.isSaveReport = false;
  }
  cancelExportPopup() {
    this.visibleExportReportPopup.close();
  }

  reportTemplateFieldValidation: any;
  exportReportGenerateFuntion() {
    this.reportTemplateFieldValidation = document.getElementById('reportTemplate-validation') as HTMLInputElement;
    if (this.selectedReportTemplateValue == null || this.selectedReportTemplateValue == "") {
      alert('Please enter the all mandatory fields...');
      this.reportTemplateFieldValidation.style.color = 'red';
    } else {
      let data1: any = {};

      this.auData.templateId = 17337;
      let y: number = +this.message.getUserId();
      this.auData.userId = y

      let templateName = this.reportTemplateDropdown.find((report: any) => this.selectedReportTemplateValue == report.valueExp);
      let thirdL = this.message.breadcrumbData.secondLevel.split('>');
      data1 = {
        "groupId": this.selectedAuditGroup[0]?.valueExp + "",
        "gridName": "AU",
        "templateId": this.selectedReportTemplateValue ?? null,
        "logoId": this.selectedReportLogoValue ?? null,
        "isSaveRep": this.isSaveReport ? 'Y' : 'N',
        "footer": this.selectedReportFooter ?? null,
        "reportName": this.reportName ?? "Report",
        "currentStatus": this.qmsService.activity.status,
        "groupName": thirdL[1],
        "templateName": this.selectedReportTemplateValue ? templateName : null,
        "AUid": this.message.activityId,
        "version": "0",
        "AUId": this.qmsService.activity.auId

      }
      this.isProcessing = true;
      if (this.selectedTab == 'Annual Audit Schedule') {
        this.appService.genRateAUScheduleReport(data1).subscribe((response: any) => {
          const blob = new Blob([response.body], { type: "application/pdf" });
          let downloadURL = globalThis.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          const firstst = this.message.breadcrumbData.firstLevel;
          const secondnd = this.message.breadcrumbData.secondLevel;
          const thirdL = this.message.breadcrumbData.thirdLevel;
          const fourthL = this.message.breadcrumbData.fourthLevel;

          let fileName = "";
          if (firstst != null) {
            fileName = firstst + "_";
          }
          if (secondnd != null) {
            fileName = fileName + secondnd + "_";
          }
          if (thirdL != null) {
            fileName = fileName + thirdL + "_";
          }
          if (fourthL != null) {
            fileName = fileName + fourthL + "_";
          }
          link.download = fileName + Date.now() + ".pdf";
          link.click();
          this.isProcessing = false;
        })
      } else if (this.selectedTab == 'Audit Plan') {
        this.appService.genRateAUPlanReport(data1).subscribe((response: any) => {
          const blob = new Blob([response.body], { type: "application/pdf" });
          let downloadURL = globalThis.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          const firstst = this.message.breadcrumbData.firstLevel;
          const secondnd = this.message.breadcrumbData.secondLevel;
          const thirdL = this.message.breadcrumbData.thirdLevel;
          const fourthL = this.message.breadcrumbData.fourthLevel;

          let fileName = "";
          if (firstst != null) {
            fileName = firstst + "_";
          }
          if (secondnd != null) {
            fileName = fileName + secondnd + "_";
          }
          if (thirdL != null) {
            fileName = fileName + thirdL + "_";
          }
          if (fourthL != null) {
            fileName = fileName + fourthL + "_";
          }
          link.download = fileName + Date.now() + ".pdf";
          link.click();
          this.isProcessing = false;
        })
      }
    }
  }

  exportReportCancelPopupFuntion() {
    this.visibleExportReportPopup.close();
  }

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  reportLogoFieldValidation: any;
  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;

  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }
    }
  }

  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList) {
        if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
          this.reportLogoDropdown = this.reportLogoDropdown.concat({
            valueExp: 0,
            displayExp: 'Default'
          });
        } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
          this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
          for (let i = 0; i < this.imageIdList.length; i++) {
            if (i == 0 && this.imageIdList[i] == 'Default') {
              this.reportLogoDropdown = this.reportLogoDropdown.concat({
                valueExp: 0,
                displayExp: 'Default'
              });
            } else {
              for (const element of this.organizationReportImageDetails) {

                if (element.reportImageId == this.imageIdList[i]) {
                  this.reportLogoDropdown = this.reportLogoDropdown.concat({
                    valueExp: element.reportImageId,
                    displayExp: element.reportImageName
                  });
                }
              }
            }
          }
        } else {
          for (const element of this.organizationReportImageDetails) {
            if (element.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
              this.reportLogoDropdown = this.reportLogoDropdown.concat({
                valueExp: element.reportImageId,
                displayExp: element.reportImageName
              });
            }
          }
        }
      }
      if (this.dropDownDataForReportLogo) {
        if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
          for (const element of this.reportLogoDropdown) {
            if (element.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
              this.selectedReportLogoValue = element.valueExp;
            }
          }
        } else {
          this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
        }
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  };

  //PDF report code end

  limitCharacters(event: Event, field: any) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    let charLimit: any = null;

    const fieldMapping: Record<number, string[]> = {
      400: ['SHORT_DESCRIPTION'],
      4000: ['BUSINESS_AREA']
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = Number(limit);
        break;
      }
    }

    if (textLength > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      target.value = target.value.substring(0, charLimit);
    }
  }
  reportFooterfieldValidation1: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterfieldValidation1 != undefined) {
        this.reportFooterfieldValidation1.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;

        this.selectBoxForFooter();
        if (this.reportFooterDropdown.length > 0) {
          this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
        }
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes("AU")) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }
    }
  }

  public getSwitchUserPrivilege(): boolean {
    return this.message.showSwitchUser && this.operationFlag != 'ADD' && this.auData.status != "Closed" && this.auData.status != "Obsoleted" && this.auData.status != "Deleted";
  }

  public focusEmpty(): void {
    console.log();
  }

}
